/**
 * LSG Icons Data
 * 
 * Este archivo es generado automáticamente por scripts/extractLsgIcons.js
 * No editar manualmente. Para actualizar, ejecutar: npm run extract-icons
 * 
 * Total de iconos: 93
 * Generado: 2025-09-30T18:25:11.396Z
 */

export const lsgIcons = {
  "AI": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "m 0,0 -42.159,9.378 -9.425,42.184 h -9.375 l -9.408,-42.184 -42.155,-9.379 v -9.367 l 42.064,-9.439 9.499,-42.153 h 9.375 l 9.492,42.062 L 0,-9.382 Z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,256.26107,181.24573)"
      },
      {
        "d": "m 0,0 -4.694,18.772 h -9.362 L -18.75,0 -37.5,-4.666 v -9.371 l 18.75,-4.691 4.681,-18.761 h 9.388 L 0,-18.728 l 18.761,4.684 v 9.378 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,268.75387,237.51813)"
      }
    ]
  },
  "AlarmClock": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "m 0,0 h -18.75 v -28.125 l 9.375,-9.335 H 18.75 v 18.67 H 0 Z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,212.5,175)"
      },
      {
        "d": "m 0,0 c -25.875,0 -46.852,20.976 -46.852,46.852 0,25.875 20.977,46.851 46.852,46.851 25.875,0 46.852,-20.976 46.852,-46.851 C 46.852,20.976 25.875,0 0,0 m -46.875,112.396 c 5.178,0 9.375,-4.198 9.375,-9.375 0,-0.935 -0.141,-1.837 -0.396,-2.689 -2.824,-2.002 -5.485,-4.217 -7.955,-6.63 10e-4,0.001 0.002,0.002 0.003,0.003 -0.338,-0.037 -0.679,-0.059 -1.027,-0.059 -5.178,0 -9.375,4.197 -9.375,9.375 0,5.177 4.197,9.375 9.375,9.375 m 83.976,-9.375 c 0,5.177 4.197,9.375 9.375,9.375 5.177,0 9.375,-4.198 9.375,-9.375 0,-5.178 -4.198,-9.375 -9.375,-9.375 -0.205,0 -0.402,0.021 -0.602,0.034 -2.615,2.557 -5.442,4.895 -8.453,6.989 -0.196,0.754 -0.32,1.537 -0.32,2.352 m 37.5,0.003 c 0,15.531 -12.591,28.122 -28.122,28.122 -13.282,0 -24.401,-9.212 -27.347,-21.592 -6.054,1.843 -12.476,2.842 -19.132,2.842 -6.791,0 -13.341,-1.032 -19.502,-2.947 -2.908,12.434 -14.056,21.697 -27.376,21.697 -15.531,0 -28.122,-12.591 -28.122,-28.122 0,-11.535 6.947,-21.442 16.882,-25.78 v 0 c -4.786,-9.108 -7.507,-19.47 -7.507,-30.473 0,-15.661 5.494,-30.033 14.648,-41.315 l -14.648,-14.935 9.348,-9.375 14.844,14.741 c 11.299,-9.212 25.719,-14.741 41.433,-14.741 15.744,0 30.188,5.549 41.496,14.791 l 14.896,-14.791 9.348,9.375 -14.713,15 c 9.124,11.272 14.598,25.619 14.598,41.25 0,11.064 -2.75,21.482 -7.586,30.627 9.761,4.411 16.562,14.218 16.562,25.626",
        "transform": "matrix(1.3333333,0,0,-1.3333333,200,274.86093)"
      }
    ]
  },
  "Award": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "m 0,0 h 6.452 l 7.6,5.522 7.6,-5.522 h 6.451 l -4.135,12.726 8.832,6.417 v 5.241 H 20.181 L 16.516,35.662 H 11.587 L 7.923,24.384 H -4.7 v -5.238 l 8.835,-6.42 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,181.26347,195.05627)"
      },
      {
        "d": "M 0,0 -9.375,-9.401 V -4.652 23.45 H 0 Z m -28.125,-4.675 h -0.002 c -0.006,-20.713 -16.792,-37.502 -37.498,-37.502 -20.707,0 -37.493,16.79 -37.5,37.502 v 0 37.5 h 75 z M -121.875,-9.401 -131.25,0 v 23.45 h 9.375 V -4.652 Z M 9.375,32.856 h -18.75 l -18.75,18.719 h -93.75 V 32.856 h -18.75 V -4.7 l 24.227,-24.205 c 7.761,-16.234 23.078,-28.152 41.398,-31.227 v -19.543 h -18.75 v -18.75 h 56.25 v 18.75 h -18.75 v 19.543 c 18.32,3.075 33.637,14.993 41.398,31.227 L 9.375,-4.7 Z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,287.5,168.7672)"
      }
    ]
  },
  "Battery": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "M 206.25,112.5 H 84.375 v 75 H 206.25 Z m 28.125,56.25 H 225 v 37.5 H 65.625 V 93.75 H 206.25 L 225,112.5 v 18.75 h 9.375 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,0,400)"
      },
      {
        "d": "M 112.5,178.125 H 93.75 v -56.25 h 18.75 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,0,400)"
      },
      {
        "d": "m 140.625,178.125 h -18.75 v -56.25 h 18.75 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,0,400)"
      },
      {
        "d": "M 168.75,178.125 H 150 v -56.25 h 18.75 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,0,400)"
      }
    ]
  },
  "BrandAmbassador": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "M 0,0 H 6.453 L 14.055,5.523 21.657,0 h 6.453 l -4.136,12.729 8.834,6.419 V 24.39 H 20.186 L 16.52,35.671 H 11.59 L 7.925,24.39 H -4.701 v -5.24 l 8.837,-6.421 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,181.248,186.15613)"
      },
      {
        "d": "m 0,0 -26.618,9.375 -26.613,-9.373 9.81,30.641 c 5.31,-1.661 10.957,-2.557 16.813,-2.557 5.854,0 11.498,0.895 16.805,2.554 z m -26.614,121.865 c 20.708,0 37.495,-16.788 37.495,-37.496 0,-11.201 -4.918,-21.248 -12.705,-28.119 -2.461,-2.171 -5.209,-4.025 -8.179,-5.497 -0.025,-0.012 -0.05,-0.026 -0.075,-0.038 -0.403,-0.199 -0.813,-0.386 -1.225,-0.571 -0.125,-0.056 -0.248,-0.115 -0.374,-0.169 -0.364,-0.159 -0.733,-0.308 -1.103,-0.455 -0.179,-0.071 -0.358,-0.144 -0.538,-0.212 -0.341,-0.129 -0.685,-0.251 -1.03,-0.371 -0.217,-0.075 -0.434,-0.15 -0.653,-0.221 -0.324,-0.106 -0.649,-0.206 -0.977,-0.303 -0.248,-0.073 -0.498,-0.144 -0.748,-0.212 -0.309,-0.084 -0.619,-0.166 -0.931,-0.243 -0.277,-0.067 -0.555,-0.13 -0.834,-0.192 -0.296,-0.065 -0.591,-0.13 -0.889,-0.188 -0.305,-0.06 -0.611,-0.112 -0.918,-0.164 -0.281,-0.048 -0.561,-0.097 -0.844,-0.139 -0.338,-0.049 -0.679,-0.089 -1.02,-0.129 -0.258,-0.031 -0.514,-0.065 -0.774,-0.091 -0.392,-0.038 -0.788,-0.064 -1.184,-0.09 -0.214,-0.014 -0.427,-0.034 -0.642,-0.045 -0.614,-0.03 -1.231,-0.047 -1.852,-0.047 -0.621,0 -1.239,0.017 -1.852,0.047 -0.215,0.011 -0.428,0.031 -0.642,0.045 -0.396,0.026 -0.792,0.052 -1.185,0.09 -0.259,0.026 -0.515,0.06 -0.772,0.091 -0.342,0.04 -0.683,0.08 -1.022,0.129 -0.282,0.042 -0.562,0.091 -0.843,0.139 -0.307,0.052 -0.614,0.104 -0.919,0.164 -0.297,0.058 -0.593,0.123 -0.888,0.188 -0.279,0.062 -0.558,0.125 -0.835,0.193 -0.311,0.076 -0.621,0.157 -0.929,0.242 -0.252,0.068 -0.502,0.139 -0.751,0.213 -0.327,0.096 -0.652,0.196 -0.974,0.302 -0.22,0.071 -0.438,0.146 -0.655,0.221 -0.345,0.12 -0.689,0.242 -1.029,0.371 -0.181,0.069 -0.36,0.141 -0.539,0.212 -0.37,0.147 -0.739,0.296 -1.102,0.455 -0.126,0.054 -0.251,0.113 -0.376,0.17 -0.411,0.184 -0.821,0.371 -1.224,0.57 -0.025,0.012 -0.05,0.026 -0.076,0.038 -2.969,1.473 -5.717,3.326 -8.178,5.497 -7.787,6.871 -12.705,16.918 -12.705,28.119 0,20.708 16.787,37.496 37.496,37.496 m 56.276,-37.51 c 0,31.077 -25.193,56.27 -56.27,56.27 -31.077,0 -56.269,-25.193 -56.269,-56.27 0,-18.405 8.838,-34.745 22.501,-45.011 L -82.89,-28.125 -26.618,-9.375 29.649,-28.125 7.154,39.339 C 20.82,49.605 29.662,65.947 29.662,84.355",
        "transform": "matrix(1.3333333,0,0,-1.3333333,235.47987,275)"
      }
    ]
  },
  "Browser": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "m 84.375,159.381 h 131.26 V 103.125 H 84.375 Z m 131.26,9.322 H 84.375 v 28.172 h 131.26 z M 65.625,84.375 h 168.75 v 131.25 H 65.625 Z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,0,400)"
      },
      {
        "d": "m 206.25,187.5 h -9.375 v -9.375 h 9.375 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,0,400)"
      },
      {
        "d": "m 192.187,187.5 h -9.375 v -9.375 h 9.375 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,0,400)"
      },
      {
        "d": "m 178.125,187.5 h -9.375 v -9.375 h 9.375 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,0,400)"
      }
    ]
  },
  "Bullseye": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "m 0,0 c 0,-5.178 4.197,-9.375 9.375,-9.375 5.178,0 9.375,4.197 9.375,9.375 0,0.003 0,0.007 0,0.01 l 56.243,56.244 h 9.375 l 9.378,9.375 H 74.993 v 18.75 L 65.618,75.004 V 65.629 L 9.375,9.375 C 4.197,9.375 0,5.178 0,0",
        "transform": "matrix(1.3333333,0,0,-1.3333333,175.00947,200.00467)"
      },
      {
        "d": "m 0,0 c 5.432,-9.552 8.545,-20.594 8.545,-32.368 0,-36.243 -29.381,-65.625 -65.625,-65.625 -36.243,0 -65.625,29.382 -65.625,65.625 0,36.244 29.382,65.625 65.625,65.625 10.875,0 21.121,-2.661 30.147,-7.349 L -13.17,39.67 c -12.79,7.822 -27.819,12.337 -43.91,12.337 -46.599,0 -84.375,-37.776 -84.375,-84.375 0,-46.599 37.776,-84.375 84.375,-84.375 46.599,0 84.375,37.776 84.375,84.375 0,16.512 -4.765,31.899 -12.966,44.905 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,263.61107,156.84293)"
      },
      {
        "d": "m 0,0 15.935,15.935 c -4.975,1.806 -10.33,2.816 -15.93,2.816 -25.888,0 -46.875,-20.986 -46.875,-46.875 0,-25.888 20.987,-46.875 46.875,-46.875 25.888,0 46.875,20.987 46.875,46.875 0,7.023 -1.551,13.681 -4.319,19.66 L 27.39,-21.738 c 0.478,-2.052 0.739,-4.188 0.739,-6.386 0,-15.533 -12.592,-28.125 -28.125,-28.125 -15.532,0 -28.124,12.592 -28.124,28.125 0,15.531 12.589,28.122 28.12,28.124",
        "transform": "matrix(1.3333333,0,0,-1.3333333,187.49827,162.50173)"
      }
    ]
  },
  "Calculator": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "M 206.25,93.75 H 93.75 v 112.5 h 112.5 z M 75,225 V 75 H 206.25 L 225,93.75 V 225 Z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,0,400)"
      },
      {
        "d": "m 187.5,187.5 h -75 v -18.75 h 75 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,0,400)"
      },
      {
        "d": "M 0,0 C 5.178,0 9.375,4.197 9.375,9.375 9.375,14.553 5.178,18.75 0,18.75 -5.178,18.75 -9.375,14.553 -9.375,9.375 -9.375,4.197 -5.178,0 0,0",
        "transform": "matrix(1.3333333,0,0,-1.3333333,162.5,250)"
      },
      {
        "d": "M 0,0 C 5.178,0 9.375,4.197 9.375,9.375 9.375,14.553 5.178,18.75 0,18.75 -5.178,18.75 -9.375,14.553 -9.375,9.375 -9.375,4.197 -5.178,0 0,0",
        "transform": "matrix(1.3333333,0,0,-1.3333333,162.5,212.5)"
      },
      {
        "d": "m 0,0 c -5.178,0 -9.375,-4.197 -9.375,-9.375 0,-5.178 4.197,-9.375 9.375,-9.375 5.178,0 9.375,4.197 9.375,9.375 C 9.375,-4.197 5.178,0 0,0",
        "transform": "matrix(1.3333333,0,0,-1.3333333,200,225)"
      },
      {
        "d": "m 0,0 c -5.178,0 -9.375,-4.197 -9.375,-9.375 0,-5.178 4.197,-9.375 9.375,-9.375 5.178,0 9.375,4.197 9.375,9.375 C 9.375,-4.197 5.178,0 0,0",
        "transform": "matrix(1.3333333,0,0,-1.3333333,200,187.5)"
      },
      {
        "d": "m 0,0 c -5.178,0 -9.375,-4.197 -9.375,-9.375 0,-5.178 4.197,-9.375 9.375,-9.375 5.178,0 9.375,4.197 9.375,9.375 C 9.375,-4.197 5.178,0 0,0",
        "transform": "matrix(1.3333333,0,0,-1.3333333,237.5,225)"
      },
      {
        "d": "m 0,0 c -5.178,0 -9.375,-4.197 -9.375,-9.375 0,-5.178 4.197,-9.375 9.375,-9.375 5.178,0 9.375,4.197 9.375,9.375 C 9.375,-4.197 5.178,0 0,0",
        "transform": "matrix(1.3333333,0,0,-1.3333333,237.5,187.5)"
      }
    ]
  },
  "Calendar": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "m 112.5,140.625 h 18.75 v 18.75 H 112.5 Z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,0,400)"
      },
      {
        "d": "m 140.625,140.625 h 18.75 v 18.75 h -18.75 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,0,400)"
      },
      {
        "d": "m 168.75,140.625 h 18.75 v 18.75 h -18.75 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,0,400)"
      },
      {
        "d": "m 112.5,112.5 h 18.75 v 18.75 H 112.5 Z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,0,400)"
      },
      {
        "d": "m 140.625,112.5 h 18.75 v 18.75 h -18.75 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,0,400)"
      },
      {
        "d": "m 168.75,112.5 h 18.75 v 18.75 h -18.75 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,0,400)"
      },
      {
        "d": "m 93.75,178.125 h 112.5 V 93.75 H 93.75 Z m 112.5,28.125 V 225 H 187.5 v -18.75 h -75 V 225 H 93.75 V 206.25 H 75 V 93.75 L 93.75,75 H 225 v 131.25 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,0,400)"
      }
    ]
  },
  "Careers": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "m 0,0 v 37.548 h 18.688 v -9.375 h 18.75 v 9.375 h 37.5 v -9.375 h 18.75 v 9.375 h 18.781 V 0 Z M 112.469,84.403 V 56.298 H 93.688 v 9.375 h -18.75 v -9.375 h -37.5 v 9.375 H 18.688 V 56.298 H 0 v 28.105 z m -84.406,28.145 h 56.291 v -9.375 H 28.063 Z m 75,-9.375 v 18.75 l -9.375,9.375 h -75 l -9.375,-9.375 v -18.75 H -18.812 V -18.702 h 150 v 121.875 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,125.082,275.06333)"
      }
    ]
  },
  "ChatBubble": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "m 0,0 h -56.117 c -31,0 -56.219,25.22 -56.219,56.219 0,30.999 25.219,56.218 56.219,56.218 30.999,0 56.219,-25.219 56.219,-56.185 z m -56.117,131.187 c -41.404,0 -74.969,-33.564 -74.969,-74.968 0,-41.405 33.565,-74.969 74.969,-74.969 h 74.833 l 0.136,74.969 c 0,41.404 -33.565,74.968 -74.969,74.968",
        "transform": "matrix(1.3333333,0,0,-1.3333333,274.87493,274.91627)"
      },
      {
        "d": "m 112.5,140.656 h 18.75 v 18.75 H 112.5 Z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,0,400)"
      },
      {
        "d": "m 140.664,140.656 h 18.75 v 18.75 h -18.75 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,0,400)"
      },
      {
        "d": "m 168.75,140.656 h 18.75 v 18.75 h -18.75 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,0,400)"
      }
    ]
  },
  "Checklist": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "m 121.792,197.006 h -18.75 v -18.881 h 18.75 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,0,400)"
      },
      {
        "d": "m 121.792,159.375 h -18.75 v -18.881 h 18.75 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,0,400)"
      },
      {
        "d": "m 103.042,103.06 h 18.75 v 18.881 h -18.75 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,0,400)"
      },
      {
        "d": "M 178.042,197.006 H 131.2 v -18.881 h 46.842 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,0,400)"
      },
      {
        "d": "M 178.042,159.375 H 131.2 v -18.881 h 46.842 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,0,400)"
      },
      {
        "d": "m 131.2,103.06 h 28.091 v 18.881 H 131.2 Z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,0,400)"
      },
      {
        "d": "M 0,0 -13.953,-12.523 5.587,-34.295 19.53,-34.307 56.106,6.313 42.173,18.86 12.575,-14.01 Z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,245.49213,225.2096)"
      },
      {
        "d": "M 0,0 H -90.563 V 131.249 H 3.196 V 56.248 h 18.743 v 75.001 L 3.196,149.998 h -112.507 v -168.75 h 131.25 v 18.75 L 0,-0.002 Z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,245.63667,287.498)"
      }
    ]
  },
  "Clock": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "m 0,0 c -31.051,0 -56.223,25.172 -56.223,56.223 0,31.051 25.172,56.223 56.223,56.223 31.051,0 56.223,-25.172 56.223,-56.223 C 56.223,25.172 31.051,0 0,0 m 0,131.223 c -41.421,0 -75,-33.579 -75,-75 0,-41.421 33.579,-75 75,-75 41.421,0 75,33.579 75,75 0,41.421 -33.579,75 -75,75",
        "transform": "matrix(1.3333333,0,0,-1.3333333,200,274.96373)"
      },
      {
        "d": "m 0,0 h -18.75 v -37.5 l 9.375,-9.375 H 0 18.75 v 18.75 H 0 Z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,212.5,150)"
      }
    ]
  },
  "Cloud": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "m 0,0 99.348,-0.024 c 0.683,-0.049 1.23,-0.072 1.72,-0.072 12.986,0 23.549,10.564 23.549,23.549 0,12.985 -10.563,23.548 -23.549,23.548 -1.045,0 -2.133,-0.077 -3.236,-0.23 l -10.911,-1.505 0.257,11.02 c -0.056,20.701 -16.913,37.526 -37.627,37.526 -20.703,0 -37.555,-16.806 -37.627,-37.493 0.003,-0.091 0.004,-0.181 0.004,-0.272 V 45.262 l -10.68,1.501 c -1.123,0.158 -2.235,0.238 -3.305,0.238 -12.985,0 -23.548,-10.563 -23.548,-23.548 0,-12.985 10.563,-23.549 23.548,-23.549 0.492,0 1.038,0.023 1.722,0.072 z m 101.068,-18.846 c -0.849,0 -1.719,0.031 -2.712,0.096 h -97.7 c -0.992,-0.065 -1.862,-0.096 -2.713,-0.096 -23.323,0 -42.298,18.976 -42.298,42.299 0,21.978 16.849,40.095 38.309,42.111 4.48,26.638 27.705,46.998 55.597,46.998 27.894,0 51.123,-20.364 55.598,-47.006 21.416,-2.06 38.218,-20.157 38.218,-42.103 0,-23.323 -18.975,-42.299 -42.299,-42.299",
        "transform": "matrix(1.3333333,0,0,-1.3333333,133.84373,249.9772)"
      }
    ]
  },
  "Coffee": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "M 0,0 H -0.197 C -0.079,1.549 0,3.108 0,4.687 V 18.75 c 5.169,0 9.375,-4.206 9.375,-9.375 C 9.375,4.206 5.169,0 0,0 m -60.938,-37.5 c -23.299,0 -42.187,18.888 -42.187,42.187 V 37.5 H -18.75 V 4.687 c 0,-23.299 -18.888,-42.187 -42.188,-42.187 M 0,37.5 V 56.25 H -103.125 L -121.875,37.5 V 4.687 c 0,-33.654 27.283,-60.937 60.937,-60.937 25.349,0 47.076,15.48 56.261,37.5 H 0 c 15.533,0 28.125,12.592 28.125,28.125 C 28.125,24.908 15.533,37.5 0,37.5",
        "transform": "matrix(1.3333333,0,0,-1.3333333,275,225)"
      },
      {
        "d": "m 0,0 9.031,9.031 -9.375,9.375 9.719,9.719 H -9.719 L -19.094,18.75 -9.719,9.375 -19.094,0 Z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,175.45827,137.5)"
      },
      {
        "d": "m 0,0 9.031,9.031 -9.375,9.375 9.719,9.719 H -9.719 L -19.094,18.75 -9.719,9.375 -19.094,0 Z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,225.45827,137.5)"
      }
    ]
  },
  "Coin": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "m 0,0 c -31.051,0 -56.223,25.172 -56.223,56.223 0,31.051 25.172,56.223 56.223,56.223 31.051,0 56.223,-25.172 56.223,-56.223 C 56.223,25.172 31.051,0 0,0 m 0,131.223 c -41.421,0 -75,-33.579 -75,-75 0,-41.421 33.579,-75 75,-75 41.421,0 75,33.579 75,75 0,41.421 -33.579,75 -75,75",
        "transform": "matrix(1.3333333,0,0,-1.3333333,200,274.96373)"
      },
      {
        "d": "m 0,0 c -1.553,0.984 -3.281,1.749 -5.135,2.276 -1.802,0.508 -3.62,0.925 -5.405,1.237 -1.728,0.3 -3.338,0.648 -4.787,1.034 -1.335,0.356 -2.407,0.861 -3.186,1.5 -0.657,0.54 -0.976,1.317 -0.976,2.375 0,1.536 0.422,2.594 1.29,3.238 0.963,0.719 2.178,1.067 3.716,1.067 1.896,0 3.381,-0.447 4.417,-1.329 1.023,-0.873 1.665,-2.182 1.907,-3.889 0.096,-0.986 0.771,-1.621 1.726,-1.621 h 8.727 c 0.698,0 1.102,0.29 1.318,0.533 0.217,0.244 0.459,0.681 0.377,1.382 -0.589,3.996 -2.006,7.14 -4.214,9.373 -2.025,2.048 -4.612,3.466 -7.699,4.222 v 2.07 c 0,1.057 -0.709,1.767 -1.764,1.767 h -8.211 c -1.04,0 -1.739,-0.71 -1.739,-1.767 v -1.96 c -2.234,-0.499 -4.188,-1.324 -5.817,-2.457 -1.85,-1.286 -3.277,-2.936 -4.242,-4.902 -0.958,-1.949 -1.444,-4.199 -1.444,-6.686 0,-2.778 0.492,-5.089 1.464,-6.868 0.971,-1.782 2.28,-3.201 3.89,-4.217 1.547,-0.976 3.265,-1.73 5.108,-2.242 1.757,-0.492 3.56,-0.912 5.356,-1.25 1.705,-0.32 3.303,-0.695 4.748,-1.114 1.325,-0.385 2.392,-0.923 3.169,-1.598 0.672,-0.584 0.998,-1.429 0.998,-2.584 0,-1.212 -0.224,-2.184 -0.665,-2.89 -0.428,-0.692 -1.051,-1.185 -1.906,-1.512 -0.933,-0.36 -2.117,-0.542 -3.522,-0.542 -2.623,0 -4.427,0.611 -5.362,1.817 -1.02,1.318 -1.678,3.131 -1.956,5.389 -0.081,0.965 -0.785,1.613 -1.788,1.613 h -8.69 c -1.04,0 -1.739,-0.71 -1.739,-1.767 v -0.025 l 0.002,-0.025 c 0.224,-4.458 1.566,-8.04 3.989,-10.646 2.236,-2.405 5.147,-4.051 8.662,-4.899 v -3.351 c 0,-1.057 0.699,-1.767 1.738,-1.767 h 8.212 c 1.055,0 1.764,0.71 1.764,1.767 v 3.043 c 2.498,0.445 4.691,1.252 6.531,2.403 2.081,1.307 3.705,3.053 4.827,5.191 1.115,2.135 1.68,4.672 1.68,7.542 0,2.778 -0.493,5.085 -1.465,6.857 C 2.931,-2.442 1.618,-1.025 0,0",
        "transform": "matrix(1.3333333,0,0,-1.3333333,217.778,196.1468)"
      }
    ]
  },
  "Coins": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "m 0,0 v 3.043 c 2.497,0.445 4.691,1.251 6.53,2.403 2.082,1.306 3.705,3.052 4.828,5.191 1.115,2.135 1.679,4.672 1.679,7.542 0,2.778 -0.493,5.085 -1.464,6.857 -0.973,1.769 -2.286,3.186 -3.904,4.212 -1.553,0.983 -3.281,1.749 -5.135,2.275 -1.802,0.509 -3.62,0.925 -5.405,1.238 -1.728,0.299 -3.338,0.647 -4.788,1.034 -1.334,0.356 -2.406,0.86 -3.186,1.5 -0.656,0.54 -0.976,1.317 -0.976,2.375 0,1.535 0.423,2.594 1.291,3.237 0.963,0.719 2.177,1.068 3.716,1.068 1.895,0 3.381,-0.447 4.417,-1.329 1.023,-0.873 1.665,-2.182 1.906,-3.889 0.096,-0.986 0.771,-1.621 1.727,-1.621 h 8.726 c 0.699,0 1.103,0.29 1.319,0.533 0.217,0.243 0.459,0.681 0.377,1.381 -0.59,3.997 -2.006,7.141 -4.214,9.374 -2.025,2.048 -4.612,3.466 -7.699,4.222 v 2.07 c 0,1.057 -0.709,1.767 -1.764,1.767 h -8.212 c -1.04,0 -1.738,-0.71 -1.738,-1.767 v -1.96 c -2.235,-0.499 -4.188,-1.324 -5.817,-2.457 -1.85,-1.286 -3.278,-2.936 -4.243,-4.902 -0.958,-1.949 -1.443,-4.199 -1.443,-6.686 0,-2.779 0.492,-5.089 1.463,-6.868 0.972,-1.782 2.281,-3.201 3.891,-4.217 1.547,-0.976 3.265,-1.73 5.107,-2.243 1.758,-0.491 3.56,-0.911 5.357,-1.249 1.705,-0.32 3.302,-0.695 4.748,-1.114 1.325,-0.385 2.392,-0.923 3.169,-1.599 0.671,-0.583 0.998,-1.428 0.998,-2.584 0,-1.211 -0.224,-2.183 -0.665,-2.889 -0.429,-0.692 -1.051,-1.186 -1.906,-1.512 -0.934,-0.36 -2.118,-0.543 -3.523,-0.543 -2.623,0 -4.427,0.612 -5.362,1.818 -1.019,1.318 -1.677,3.131 -1.956,5.389 -0.08,0.965 -0.784,1.613 -1.788,1.613 h -8.689 c -1.04,0 -1.739,-0.71 -1.739,-1.767 v -0.025 l 0.001,-0.025 c 0.224,-4.458 1.567,-8.04 3.99,-10.647 2.235,-2.404 5.146,-4.05 8.662,-4.898 V 0 c 0,-1.057 0.698,-1.767 1.738,-1.767 h 8.212 C -0.709,-1.767 0,-1.057 0,0",
        "transform": "matrix(1.3333333,0,0,-1.3333333,182.6168,222.64387)"
      },
      {
        "d": "m 0,0 c -4.446,0 -8.766,0.532 -12.914,1.508 0,0 0,0 -10e-4,0 34.153,7.012 59.838,37.238 59.838,73.465 0,4.845 -0.477,9.576 -1.354,14.165 0,-0.001 0,-0.001 0,-0.001 C 52.265,79.883 56.223,68.518 56.223,56.223 56.223,25.172 31.051,0 0,0 m -84.3,74.973 c 0,31.051 25.172,56.223 56.223,56.223 31.051,0 56.223,-25.172 56.223,-56.223 0,-31.051 -25.172,-56.223 -56.223,-56.223 -31.051,0 -56.223,25.172 -56.223,56.223 m 110.793,51.421 c 0,0 0,-0.001 0,-0.001 -13.676,14.509 -33.058,23.58 -54.57,23.58 -41.422,0 -75,-33.579 -75,-75 0,-32.093 20.163,-59.464 48.507,-70.171 13.676,-14.508 33.058,-23.579 54.57,-23.579 41.421,0 75,33.579 75,75 0,32.092 -20.163,59.464 -48.507,70.171",
        "transform": "matrix(1.3333333,0,0,-1.3333333,212.5,287.46373)"
      }
    ]
  },
  "Colombia": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "m 84.375,126.563 h 131.25 v -18.75 H 84.375 Z m 131.25,9.374 H 84.375 v 18.75 h 131.25 z m 0,28.125 H 84.375 v 28.125 h 131.25 z m -150,46.875 V 89.063 h 150 l 18.75,18.75 v 103.124 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,0,400)"
      }
    ]
  },
  "ComputerMonitor": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "m 84.375,196.875 h 131.26 V 131.25 H 84.375 Z m 150,-84.375 V 215.625 H 65.625 V 112.5 h 75.146 v -9.447 H 121.875 V 84.351 h 56.25 v 18.702 h -18.896 v 9.447 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,0,400)"
      }
    ]
  },
  "Conversation": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "m 0,0 h -37.413 c -20.667,0 -37.48,16.814 -37.48,37.48 0,20.667 16.813,37.48 37.48,37.48 20.667,0 37.481,-16.813 37.481,-37.446 z m -37.413,93.71 c -31.055,0 -56.23,-25.175 -56.23,-56.23 0,-31.055 25.175,-56.23 56.23,-56.23 h 56.129 l 0.102,56.23 c 0,31.055 -25.175,56.23 -56.231,56.23",
        "transform": "matrix(1.3333333,0,0,-1.3333333,274.85227,224.9524)"
      },
      {
        "d": "m 0,0 c -6.626,-5.904 -15.351,-9.502 -24.903,-9.502 h -37.413 l -0.068,37.48 c 0,9.54 3.588,18.253 9.478,24.876 -0.063,1.085 -0.103,2.177 -0.103,3.278 0,8.233 1.784,16.044 4.963,23.09 -19.507,-8.824 -33.088,-28.441 -33.088,-51.244 l 0.102,-56.23 h 56.129 c 20.825,0 38.993,11.33 48.711,28.154 H 3.222 C 2.14,-0.098 1.067,-0.06 0,0",
        "transform": "matrix(1.3333333,0,0,-1.3333333,208.2044,262.30093)"
      },
      {
        "d": "m 150,164.078 h 9.375 v 9.375 H 150 Z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,0,400)"
      },
      {
        "d": "m 164.039,164.078 h 9.375 v 9.375 h -9.375 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,0,400)"
      },
      {
        "d": "m 178.125,164.078 h 9.375 v 9.375 h -9.375 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,0,400)"
      }
    ]
  },
  "Cross": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "m 0,0 h -46.875 v -46.875 h -18.75 V 0 H -112.5 v 18.75 h 46.875 v 46.875 h 18.75 V 18.75 H 0 Z m -28.125,37.5 v 28.125 l -18.75,18.75 h -37.5 V 37.5 h -46.875 v -56.25 h 46.875 v -46.875 h 56.25 V -18.75 H 18.75 V 37.5 Z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,275,212.5)"
      }
    ]
  },
  "CustomerSupport": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "M 0,0 0.001,32.693 C 5.661,29.433 9.489,23.334 9.489,16.347 9.489,9.359 5.661,3.26 0,0 m -112.499,0.02 c -4.079,2.343 -7.211,6.156 -8.637,10.724 -0.552,1.771 -0.849,3.653 -0.849,5.603 0,1.297 0.132,2.564 0.382,3.788 1.101,5.362 4.498,9.886 9.104,12.532 z m 111.88,52.787 c -4.029,27.111 -27.398,47.911 -55.63,47.911 -28.232,0 -51.601,-20.801 -55.631,-47.912 -16.466,-3.956 -28.744,-18.796 -28.744,-36.459 0,-20.678 16.822,-37.501 37.499,-37.503 l 0.001,-0.001 h 9.375 v 0.083 l 0.002,65.564 h 0.072 c 0,20.681 16.766,37.447 37.447,37.447 20.682,0 37.447,-16.766 37.447,-37.447 h 0.023 l 0.009,-46.886 -28.424,-28.136 h -18.451 v -18.75 h 28.125 l 28.124,28.125 c 20.679,0 37.503,16.825 37.503,37.504 0,17.664 -12.279,32.505 -28.747,36.46",
        "transform": "matrix(1.3333333,0,0,-1.3333333,274.9984,234.2912)"
      }
    ]
  },
  "Cycle": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "m 0,0 v -18.75 h 13.741 c -10.29,-11.485 -25.224,-18.72 -41.86,-18.72 -31.05,0 -56.222,25.171 -56.222,56.222 h -18.778 c 0,-41.421 33.579,-75 75,-75 22.404,0 42.498,9.834 56.236,25.411 v -16.076 h 18.75 V -9.375 L 37.492,0 Z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,237.4916,225.0032)"
      },
      {
        "d": "m 0,0 v 18.75 h -13.737 c 10.29,11.486 25.226,18.723 41.862,18.723 31.051,0 56.223,-25.172 56.223,-56.223 h 18.777 c 0,41.421 -33.579,75 -75,75 -22.407,0 -42.504,-9.836 -56.242,-25.417 v 16.08 h -18.75 V 9.375 L -37.492,0 Z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,162.5,175)"
      }
    ]
  },
  "DataScience": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "m 178.125,225 h 18.75 V 75 h -18.75 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,0,400)"
      },
      {
        "d": "m 140.625,187.5 h 18.75 V 75 h -18.75 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,0,400)"
      },
      {
        "d": "m 103.125,150.068 h 18.75 V 75 h -18.75 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,0,400)"
      }
    ]
  },
  "Document": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "m 196.882,84.377 h -93.759 v 131.249 h 93.759 z M 84.375,234.375 V 65.625 h 112.5 l 18.75,18.752 v 149.998 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,0,400)"
      },
      {
        "d": "m 178.125,197.006 h -56.25 v -18.881 h 56.25 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,0,400)"
      },
      {
        "d": "m 178.125,159.375 h -56.25 v -18.881 h 56.25 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,0,400)"
      },
      {
        "d": "m 178.125,121.94 h -56.25 v -18.881 h 56.25 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,0,400)"
      }
    ]
  },
  "Endorsement": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "m 0,0 h -56.117 c -31,0 -56.219,25.22 -56.219,56.219 0,30.999 25.219,56.218 56.219,56.218 30.999,0 56.219,-25.219 56.219,-56.185 z m -56.117,131.187 c -41.404,0 -74.969,-33.564 -74.969,-74.968 0,-41.405 33.565,-74.969 74.969,-74.969 h 74.834 l 0.135,74.969 c 0,41.404 -33.565,74.968 -74.969,74.968",
        "transform": "matrix(1.3333333,0,0,-1.3333333,274.87493,274.91627)"
      },
      {
        "d": "m 0,0 h -4.93 l -3.666,-11.281 h -12.625 v -5.239 l 8.837,-6.421 -4.137,-12.73 h 6.454 l 7.602,5.524 7.601,-5.524 h 6.454 l -4.136,12.73 8.834,6.418 v 5.242 H 3.665 Z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,203.28907,176.2196)"
      }
    ]
  },
  "FinancialInsurance": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "m 0,0 c 0,-28.138 -42.206,-56.275 -56.275,-56.275 -14.069,0 -56.275,28.137 -56.275,56.275 V 56.275 H 0 Z M -0.05,75.025 H -131.3 v -75 c 0,-37.5 56.25,-75 75,-75 18.75,0 75,37.5 75,75 v 56.288 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,275.06707,200.03347)"
      },
      {
        "d": "m 0,0 c 2.235,-2.405 5.146,-4.05 8.662,-4.898 v -3.351 c 0,-1.057 0.698,-1.767 1.738,-1.767 h 8.212 c 1.055,0 1.764,0.71 1.764,1.767 v 3.043 c 2.497,0.444 4.691,1.251 6.53,2.403 2.082,1.306 3.705,3.052 4.828,5.19 1.115,2.135 1.679,4.673 1.679,7.543 0,2.778 -0.493,5.084 -1.465,6.856 -0.972,1.77 -2.285,3.187 -3.903,4.212 -1.553,0.984 -3.281,1.75 -5.135,2.276 -1.802,0.509 -3.62,0.925 -5.405,1.237 -1.728,0.3 -3.338,0.648 -4.788,1.035 -1.334,0.355 -2.406,0.86 -3.186,1.499 -0.656,0.54 -0.976,1.318 -0.976,2.376 0,1.535 0.423,2.594 1.291,3.237 0.963,0.719 2.177,1.067 3.716,1.067 1.895,0 3.381,-0.447 4.417,-1.329 1.023,-0.873 1.665,-2.181 1.906,-3.889 0.096,-0.985 0.771,-1.62 1.727,-1.62 h 8.726 c 0.699,0 1.103,0.289 1.319,0.532 0.217,0.244 0.458,0.682 0.377,1.382 -0.59,3.997 -2.006,7.14 -4.214,9.373 -2.025,2.048 -4.612,3.466 -7.699,4.222 v 2.071 c 0,1.056 -0.709,1.767 -1.764,1.767 h -8.212 c -1.04,0 -1.738,-0.711 -1.738,-1.767 V 42.506 C 6.172,42.007 4.219,41.183 2.59,40.05 0.74,38.763 -0.688,37.114 -1.653,35.148 c -0.958,-1.949 -1.443,-4.199 -1.443,-6.687 0,-2.778 0.492,-5.089 1.463,-6.867 0.972,-1.782 2.281,-3.201 3.891,-4.218 1.547,-0.975 3.265,-1.729 5.107,-2.242 1.758,-0.491 3.56,-0.912 5.357,-1.249 1.705,-0.321 3.302,-0.695 4.748,-1.114 1.325,-0.386 2.392,-0.924 3.169,-1.599 0.671,-0.584 0.998,-1.429 0.998,-2.584 0,-1.212 -0.224,-2.184 -0.665,-2.889 C 20.543,5.006 19.921,4.513 19.066,4.187 18.132,3.826 16.948,3.644 15.543,3.644 c -2.623,0 -4.427,0.612 -5.362,1.818 -1.019,1.317 -1.677,3.13 -1.956,5.388 -0.08,0.966 -0.784,1.614 -1.788,1.614 h -8.689 c -1.04,0 -1.739,-0.71 -1.739,-1.767 V 10.672 L -3.99,10.647 C -3.766,6.189 -2.423,2.607 0,0",
        "transform": "matrix(1.3333333,0,0,-1.3333333,180.38507,211.6448)"
      }
    ]
  },
  "FinancialServices": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "m 0,0 c -12.944,0 -23.437,-10.493 -23.437,-23.437 0,-12.945 10.493,-23.438 23.437,-23.438 12.944,0 23.437,10.493 23.437,23.438 C 23.437,-10.493 12.944,0 0,0",
        "transform": "matrix(1.3333333,0,0,-1.3333333,175,150)"
      },
      {
        "d": "m 0,0 h -131.25 v 9.338 h 112.5 V 84.376 H 0 Z M -168.75,112.465 H -37.5 V 28.089 H -168.75 Z M 0,103.124 h -18.75 v 9.339 l -18.75,18.75 h -150 V 9.338 H -150 V -18.751 H 18.75 V 84.374 Z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,312.49933,274.95067)"
      }
    ]
  },
  "Folder": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "m 0,0 h -131.249 l 0.001,75.008 H 0.001 Z m 0.001,93.751 h -84.374 v 9.375 l -9.375,9.375 h -46.875 v -18.75 h -9.375 l -0.001,-112.499 h 168.75 l 10e-4,93.749 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,287.4968,262.49813)"
      }
    ]
  },
  "FoodAndBeverage": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "m 0,0 c -10.364,0 -18.766,8.402 -18.766,18.766 0,10.364 8.402,18.766 18.766,18.766 10.364,0 18.766,-8.402 18.766,-18.766 C 18.766,8.402 10.364,0 0,0 m 0,56.313 c -20.711,0 -37.5,-16.789 -37.5,-37.5 0,-17.476 11.955,-32.16 28.133,-36.32 v -76.18 H 9.367 v 76.18 c 16.178,4.16 28.133,18.844 28.133,36.32 0,20.711 -16.789,37.5 -37.5,37.5",
        "transform": "matrix(1.3333333,0,0,-1.3333333,137.5,175.08427)"
      },
      {
        "d": "M 0,0 V 18.835 L -18.734,37.547 V 0 l 0.008,-0.002 c -0.001,-10.363 -8.403,-18.764 -18.766,-18.764 -10.364,0 -18.766,8.402 -18.766,18.766 V 37.547 H -74.992 V 0 h 0.001 c 0.022,-17.456 11.969,-32.117 28.132,-36.273 v -76.18 h 18.734 v 76.18 C -11.962,-32.117 -0.015,-17.455 0.007,0 Z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,312.4896,150.0632)"
      },
      {
        "d": "m 206.242,225 h -18.734 v -37.5 h 18.734 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,0,400)"
      }
    ]
  },
  "FullstackDevelopment": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "M 0,0 -33.159,-16.642 -66.309,0 l 16.433,8.224 16.715,-8.391 16.723,8.393 z M -33.161,37.319 -16.47,45.696 0,37.455 -33.159,20.813 l -33.15,16.642 16.464,8.24 z M -33.159,91.532 0,74.94 -33.159,58.298 -66.309,74.94 Z M 4.45,56.195 41.852,74.966 -33.161,112.499 -108.15,74.966 -70.76,56.195 -108.15,37.48 -70.791,18.724 -108.15,0.025 -33.161,-37.622 41.852,0.025 4.48,18.725 41.852,37.48 Z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,244.2136,249.93747)"
      }
    ]
  },
  "Funnel": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "M 0,0 H 18.75 V 50.758 L 65.625,97.633 V 112.5 h -112.5 V 97.633 L 0,50.758 Z m 37.5,-18.75 h -56.25 v 61.742 l -46.875,46.875 v 41.383 h 150 V 89.867 L 37.5,42.992 Z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,187.5,275)"
      }
    ]
  },
  "GlobalForwarding": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "m 0,0 h -37.5 v 28.047 h 22.298 L -5.781,9.297 H 0 Z m -131.25,0 v 46.797 h 74.945 L -56.259,0 Z M 5.781,28.047 -3.64,46.797 H -37.5 v 18.75 H -150 V -18.75 h 93.759 18.741 56.25 v 46.797 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,287.5,218.64613)"
      },
      {
        "d": "m 0,0 c -5.178,0 -9.375,-4.197 -9.375,-9.375 0,-5.178 4.197,-9.375 9.375,-9.375 5.178,0 9.375,4.197 9.375,9.375 C 9.375,-4.197 5.178,0 0,0",
        "transform": "matrix(1.3333333,0,0,-1.3333333,125,243.7496)"
      },
      {
        "d": "m 0,0 c -5.178,0 -9.375,-4.197 -9.375,-9.375 0,-5.178 4.197,-9.375 9.375,-9.375 5.178,0 9.375,4.197 9.375,9.375 C 9.375,-4.197 5.178,0 0,0",
        "transform": "matrix(1.3333333,0,0,-1.3333333,200,243.7496)"
      },
      {
        "d": "m 0,0 c -5.178,0 -9.375,-4.197 -9.375,-9.375 0,-5.178 4.197,-9.375 9.375,-9.375 5.178,0 9.375,4.197 9.375,9.375 C 9.375,-4.197 5.178,0 0,0",
        "transform": "matrix(1.3333333,0,0,-1.3333333,278.17573,243.7496)"
      }
    ]
  },
  "Globe": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "M 0,0 C 0,20.711 -8.395,39.461 -21.967,53.033 L -35.225,39.775 C -25.046,29.596 -18.75,15.533 -18.75,0 c 0,-31.066 -25.184,-56.25 -56.25,-56.25 -31.066,0 -56.25,25.184 -56.25,56.25 H -150 c 0,-38.244 28.632,-69.779 65.625,-74.396 V -93.75 h -18.75 v -18.75 h 56.25 v 18.75 h -18.75 v 19.354 C -28.632,-69.779 0,-38.244 0,0",
        "transform": "matrix(1.3333333,0,0,-1.3333333,300,150)"
      },
      {
        "d": "M 0,0 C 15.533,0 28.125,-12.592 28.125,-28.125 28.125,-43.658 15.533,-56.25 0,-56.25 c -15.533,0 -28.125,12.592 -28.125,28.125 C -28.125,-12.592 -15.533,0 0,0 m 0,-75 c 25.888,0 46.875,20.987 46.875,46.875 C 46.875,-2.237 25.888,18.75 0,18.75 -25.888,18.75 -46.875,-2.237 -46.875,-28.125 -46.875,-54.013 -25.888,-75 0,-75",
        "transform": "matrix(1.3333333,0,0,-1.3333333,200,112.5)"
      }
    ]
  },
  "Goal": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "M 140.495,196.81 H 121.81 v -18.685 h 18.685 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,0,400)"
      },
      {
        "d": "m 159.343,178.093 h -18.685 v -18.685 h 18.685 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,0,400)"
      },
      {
        "d": "m 178.044,196.81 h -18.685 v -18.685 h 18.685 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,0,400)"
      },
      {
        "d": "m 196.891,178.093 h -18.685 v -18.685 h 18.685 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,0,400)"
      },
      {
        "d": "M 206.352,150 H 112.5 v 56.22 h 93.852 z M 93.75,225 V 93.75 H 75 V 75 h 56.25 V 93.75 H 112.5 v 37.5 h 93.71 L 225,150 v 75 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,0,400)"
      }
    ]
  },
  "Guatemala": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "m 0,0 c 10.355,0 18.75,8.395 18.75,18.75 0,5.178 -2.099,9.865 -5.492,13.258 L 6.629,25.379 C 8.326,23.683 9.375,21.339 9.375,18.75 9.375,13.572 5.178,9.375 0,9.375 c -5.178,0 -9.375,4.197 -9.375,9.375 0,2.563 1.031,4.884 2.698,6.577 l -6.677,6.576 C -16.688,28.518 -18.75,23.877 -18.75,18.75 -18.75,8.395 -10.355,0 0,0",
        "transform": "matrix(1.3333333,0,0,-1.3333333,200,221.3388)"
      },
      {
        "d": "M 215.625,107.813 H 187.5 v 84.375 h 28.125 z M 84.375,192.187 H 112.5 V 107.812 H 84.375 Z m 93.75,-84.374 h -56.25 v 84.375 h 56.25 z M 187.5,210.937 H 178.125 121.875 112.5 65.625 V 89.063 h 150 l 18.75,18.75 v 103.124 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,0,400)"
      }
    ]
  },
  "HealthInsurance": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "m 0,0 c 0,-28.138 -42.206,-56.275 -56.275,-56.275 -14.069,0 -56.275,28.137 -56.275,56.275 V 56.275 H 0 Z M -0.05,75.025 H -131.3 v -75 c 0,-37.5 56.25,-75 75,-75 18.75,0 75,37.5 75,75 v 56.288 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,275.06707,200.03347)"
      },
      {
        "d": "m 0,0 c 3.491,0 31.645,14.062 31.645,38.664 0,9.711 -7.872,17.583 -17.583,17.583 -5.747,0 -10.849,-2.758 -14.058,-7.021 -3.208,4.263 -8.311,7.021 -14.058,7.021 -9.709,0 -17.579,-7.869 -17.583,-17.577 0,0 -0.002,-0.004 -0.002,-0.006 C -31.639,14.062 -3.516,0 0,0",
        "transform": "matrix(1.3333333,0,0,-1.3333333,199.99587,224.9964)"
      }
    ]
  },
  "Heart": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "m 0,0 c -4.963,-9.299 -12.034,-18.269 -21.017,-26.659 -14.554,-13.595 -29.716,-21.546 -36.104,-24.165 -6.382,2.613 -21.536,10.555 -36.089,24.156 -8.976,8.389 -16.042,17.358 -21.002,26.658 -5.509,10.332 -8.373,21.1 -8.518,32.022 v 0.884 c 0.005,15.512 12.629,28.132 28.141,28.132 8.924,0 17.127,-4.1 22.507,-11.249 l 10.305,-13.695 h 9.353 v 0 l 10.306,13.695 c 5.379,7.149 13.583,11.249 22.507,11.249 C -4.094,61.028 8.53,48.404 8.53,32.887 8.53,21.67 5.66,10.605 0,0 m -19.611,79.778 c -15.326,0 -28.933,-7.355 -37.489,-18.725 -8.556,11.37 -22.163,18.725 -37.489,18.725 -25.892,0 -46.882,-20.985 -46.891,-46.875 0,0 -0.006,-0.011 -0.006,-0.016 0,-65.609 75,-103.109 84.375,-103.109 9.309,0 84.391,37.5 84.391,103.109 0,25.897 -20.994,46.891 -46.891,46.891",
        "transform": "matrix(1.3333333,0,0,-1.3333333,276.14813,206.3704)"
      }
    ]
  },
  "HelpDeskService": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "m 0,0 c 0,25.902 -20.998,46.9 -46.901,46.9 -25.902,0 -46.9,-20.998 -46.9,-46.9 h 18.782 c 0,15.531 12.591,28.122 28.122,28.122 15.531,0 28.122,-12.591 28.122,-28.122 0,-15.531 -12.591,-28.122 -28.122,-28.122 -0.029,0 -0.058,0.002 -0.087,0.002 v -0.031 h -9.292 v -37.5 h 18.75 v 19.69 C -16.116,-41.618 0,-22.692 0,0",
        "transform": "matrix(1.3333333,0,0,-1.3333333,262.534,162.466)"
      },
      {
        "d": "m 140.625,75 h 18.75 v 18.75 h -18.75 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,0,400)"
      }
    ]
  },
  "Image": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "M 0,0 V 42.18 H 9.375 L 37.5,70.313 93.75,14.063 112.5,32.808 V 0 Z M 0,112.5 H 112.5 V 60.57 L 93.75,42.188 37.5,98.438 0,60.93 Z m -18.75,18.75 V 60.93 42.18 0 L 0,-18.75 h 131.25 v 150 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,125,275)"
      },
      {
        "d": "m 0,0 c 7.767,0 14.063,6.296 14.063,14.063 0,7.766 -6.296,14.062 -14.063,14.062 -7.767,0 -14.063,-6.296 -14.063,-14.062 C -14.063,6.296 -7.767,0 0,0",
        "transform": "matrix(1.3333333,0,0,-1.3333333,243.75,175)"
      }
    ]
  },
  "Information": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "m 0,0 c -31.051,0 -56.223,25.172 -56.223,56.223 0,31.051 25.172,56.223 56.223,56.223 31.051,0 56.223,-25.172 56.223,-56.223 C 56.223,25.172 31.051,0 0,0 m 0,131.223 c -41.421,0 -75,-33.579 -75,-75 0,-41.421 33.579,-75 75,-75 41.421,0 75,33.579 75,75 0,41.421 -33.579,75 -75,75",
        "transform": "matrix(1.3333333,0,0,-1.3333333,200,274.96373)"
      },
      {
        "d": "m 140.625,121.875 h 18.75 v 37.5 h -18.75 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,0,400)"
      },
      {
        "d": "m 140.625,168.75 h 18.75 v 9.375 h -18.75 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,0,400)"
      }
    ]
  },
  "Insurance": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "m 0,0 c 0,-28.138 -42.206,-56.275 -56.275,-56.275 -14.069,0 -56.275,28.137 -56.275,56.275 V 56.275 H 0 Z M -0.05,75.025 H -131.3 v -75 c 0,-37.5 56.25,-75 75,-75 18.75,0 75,37.5 75,75 v 56.288 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,275.06707,200.03347)"
      },
      {
        "d": "M 0,0 H 18.75 V 18.75 H 37.5 V 37.5 H 18.75 V 56.25 H 0 V 37.5 H -18.749 V 18.75 H 0 Z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,187.5,225.06067)"
      }
    ]
  },
  "Insurance02": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "m 0,0 c 0,-28.138 -42.206,-56.275 -56.275,-56.275 -14.069,0 -56.275,28.137 -56.275,56.275 V 56.275 H 0 Z M -0.05,75.025 H -131.3 v -75 c 0,-37.5 56.25,-75 75,-75 18.75,0 75,37.5 75,75 v 56.288 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,275.06707,200.03347)"
      },
      {
        "d": "M 0,0 38.647,42.92 23.925,56.178 -7.349,21.446 -20.636,36.249 -35.379,23.017 -14.733,0.012 Z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,197.82133,224.91653)"
      }
    ]
  },
  "Investment": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "m 0,0 v -18.75 h 13.791 c -10.3,-11.504 -25.259,-18.75 -41.916,-18.75 -31.066,0 -56.25,25.184 -56.25,56.25 0,31.066 25.184,56.25 56.25,56.25 31.066,0 56.25,-25.184 56.25,-56.25 h 18.75 c 0,41.421 -33.579,75 -75,75 -41.421,0 -75,-33.579 -75,-75 0,-41.421 33.579,-75 75,-75 22.407,0 42.504,9.838 56.242,25.419 v -16.082 h 18.75 V -9.375 L 37.492,0 Z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,237.5,225)"
      },
      {
        "d": "M 0,0 H 8.211 C 9.267,0 9.976,0.71 9.976,1.767 V 4.81 c 2.497,0.445 4.691,1.251 6.53,2.403 2.081,1.306 3.705,3.053 4.827,5.191 1.115,2.135 1.68,4.672 1.68,7.542 0,2.778 -0.493,5.085 -1.465,6.857 -0.972,1.77 -2.286,3.187 -3.903,4.212 -1.553,0.984 -3.281,1.749 -5.135,2.275 -1.802,0.509 -3.621,0.925 -5.406,1.238 -1.727,0.3 -3.337,0.647 -4.787,1.034 -1.334,0.356 -2.406,0.86 -3.186,1.5 -0.656,0.54 -0.976,1.317 -0.976,2.375 0,1.535 0.422,2.594 1.291,3.238 0.963,0.718 2.177,1.067 3.716,1.067 1.895,0 3.381,-0.447 4.417,-1.329 1.023,-0.873 1.664,-2.182 1.906,-3.889 0.096,-0.986 0.771,-1.621 1.727,-1.621 h 8.726 c 0.698,0 1.103,0.29 1.319,0.533 0.217,0.244 0.458,0.681 0.377,1.382 -0.59,3.996 -2.006,7.14 -4.214,9.373 -2.025,2.048 -4.612,3.466 -7.699,4.222 v 2.07 c 0,1.057 -0.709,1.767 -1.764,1.767 h -8.212 c -1.04,0 -1.738,-0.71 -1.738,-1.767 v -1.96 c -2.235,-0.499 -4.188,-1.324 -5.817,-2.457 -1.85,-1.286 -3.278,-2.936 -4.243,-4.902 -0.958,-1.949 -1.444,-4.199 -1.444,-6.686 0,-2.778 0.493,-5.089 1.464,-6.868 0.972,-1.782 2.281,-3.201 3.891,-4.217 1.547,-0.976 3.265,-1.73 5.107,-2.242 1.757,-0.492 3.56,-0.912 5.357,-1.25 1.705,-0.32 3.302,-0.695 4.748,-1.114 1.325,-0.385 2.392,-0.923 3.169,-1.599 0.671,-0.583 0.998,-1.428 0.998,-2.583 0,-1.212 -0.224,-2.184 -0.665,-2.89 C 10.143,15.023 9.521,14.529 8.666,14.203 7.732,13.843 6.548,13.66 5.143,13.66 c -2.623,0 -4.427,0.612 -5.362,1.818 -1.019,1.318 -1.677,3.131 -1.956,5.389 -0.081,0.965 -0.784,1.613 -1.788,1.613 h -8.69 c -1.039,0 -1.738,-0.71 -1.738,-1.767 v -0.025 l 10e-4,-0.025 c 0.224,-4.458 1.567,-8.04 3.99,-10.647 2.235,-2.404 5.146,-4.05 8.661,-4.898 V 1.767 C -1.739,0.71 -1.04,0 0,0",
        "transform": "matrix(1.3333333,0,0,-1.3333333,194.252,237.5)"
      }
    ]
  },
  "Leadership": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "m 0,0 c -5.15,0 -9.34,4.189 -9.34,9.34 0,5.149 4.19,9.339 9.34,9.339 5.149,0 9.339,-4.19 9.339,-9.339 C 9.339,4.189 5.149,0 0,0 m -74.811,0 c -5.15,0 -9.339,4.189 -9.339,9.34 0,5.149 4.189,9.339 9.339,9.339 5.15,0 9.339,-4.19 9.339,-9.339 0,-5.151 -4.189,-9.34 -9.339,-9.34 m -75.031,0 c -5.149,0 -9.339,4.189 -9.339,9.34 0,5.149 4.19,9.339 9.339,9.339 5.151,0 9.34,-4.19 9.34,-9.339 0,-5.151 -4.189,-9.34 -9.34,-9.34 m 60.877,117.17 c 0,7.745 6.3,14.044 14.043,14.044 7.744,0 14.045,-6.299 14.045,-14.044 0,-7.743 -6.301,-14.043 -14.045,-14.043 -7.743,0 -14.043,6.3 -14.043,14.043 M 9.454,35.787 V 56.214 L 0.079,65.589 H -65.546 V 85.75 c 13.528,4.044 23.419,16.596 23.419,31.42 0,18.083 -14.712,32.794 -32.795,32.794 -18.082,0 -32.793,-14.711 -32.793,-32.794 0,-14.825 9.892,-27.377 23.419,-31.42 V 65.589 h -65.598 l -9.402,-9.375 V 35.787 c -10.85,-3.89 -18.635,-14.275 -18.635,-26.447 0,-15.489 12.601,-28.09 28.089,-28.09 15.489,0 28.09,12.601 28.09,28.09 0,12.231 -7.861,22.655 -18.794,26.501 v 10.998 h 56.25 V 35.777 C -95.131,31.878 -102.9,21.501 -102.9,9.34 c 0,-15.489 12.6,-28.09 28.089,-28.09 15.489,0 28.089,12.601 28.089,28.09 0,12.242 -7.875,22.674 -18.824,26.511 v 10.988 h 56.25 V 35.841 C -20.229,31.995 -28.09,21.571 -28.09,9.34 c 0,-15.489 12.601,-28.09 28.09,-28.09 15.488,0 28.089,12.601 28.089,28.09 0,12.172 -7.784,22.557 -18.635,26.447",
        "transform": "matrix(1.3333333,0,0,-1.3333333,299.89453,287.4524)"
      }
    ]
  },
  "Lifesaver": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "m 0,0 -13.545,13.545 c 3.303,5.584 5.206,12.095 5.206,19.053 0,6.948 -1.897,13.45 -5.192,19.029 L 0,65.163 C 6.547,55.968 10.411,44.729 10.411,32.581 10.411,20.434 6.547,9.195 0,0 m -78.419,-13.258 13.566,13.567 c 5.58,-3.296 12.082,-5.194 19.031,-5.194 6.94,0 13.435,1.894 19.01,5.181 l 13.554,-13.554 c -9.195,-6.547 -20.433,-10.411 -32.581,-10.411 -12.147,0 -23.385,3.864 -32.58,10.411 m -23.67,45.839 c 0,12.148 3.864,23.386 10.411,32.581 l 13.554,-13.555 c -3.288,-5.574 -5.181,-12.069 -5.181,-19.009 0,-6.949 1.898,-13.452 5.194,-19.031 L -91.677,0 c -6.548,9.195 -10.412,20.433 -10.412,32.581 m 37.848,0.174 c 0,10.259 8.316,18.576 18.576,18.576 10.259,0 18.576,-8.317 18.576,-18.576 0,-10.259 -8.317,-18.576 -18.576,-18.576 -10.26,0 -18.576,8.317 -18.576,18.576 m 50.985,45.664 -13.529,-13.534 c -5.581,3.297 -12.086,5.196 -19.037,5.196 -6.959,0 -13.47,-1.903 -19.054,-5.206 L -78.42,78.42 c 9.194,6.547 20.433,10.411 32.581,10.411 12.149,0 23.388,-3.864 32.583,-10.412 m -32.583,29.162 c -41.421,0 -75,-33.578 -75,-75 0,-41.421 33.579,-75 75,-75 41.422,0 75,33.579 75,75 0,41.422 -33.578,75 -75,75",
        "transform": "matrix(1.3333333,0,0,-1.3333333,261.11853,243.44173)"
      }
    ]
  },
  "Lightbulb": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "m 0,0 h 37.5 l 9.375,9.375 h -56.25 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,175.00093,300.00027)"
      },
      {
        "d": "m 0,0 v -5.034 -15.594 -3.156 h -9.376 l 10e-4,46.875 H 0 v 9.375 h -9.375 v 10e-4 H -28.123 V 32.466 H -37.5 v -9.375 h 9.377 l -10e-4,-46.875 H -37.5 v 3.187 15.563 5.047 c -11.2,6.486 -18.739,18.591 -18.739,32.464 0,20.711 16.789,37.5 37.5,37.5 20.71,0 37.5,-16.789 37.5,-37.5 C 18.761,18.595 11.211,6.483 0,0 m 37.562,32.442 c 0,31.075 -25.191,56.267 -56.266,56.267 -31.076,0 -56.267,-25.192 -56.267,-56.267 0,-16.643 7.233,-31.589 18.721,-41.887 v -23.734 l 9.375,-9.375 h 56.25 l 9.375,9.375 v 23.653 c 11.541,10.3 18.812,25.281 18.812,41.968",
        "transform": "matrix(1.3333333,0,0,-1.3333333,225,218.28813)"
      }
    ]
  },
  "Link": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "m 0,0 c 0,0 -0.001,-0.001 -0.001,-0.001 l -18.741,-18.741 -0.002,0.001 c -0.01,-0.01 -0.019,-0.022 -0.03,-0.033 -4.909,-4.909 -11.861,-6.509 -18.118,-4.834 L -16.041,-2.751 -29.299,10.507 -50.13,-10.33 c -1.653,6.243 -0.049,13.17 4.847,18.066 0.01,0.01 0.022,0.019 0.033,0.03 l -10e-4,0.001 18.741,18.742 c 0,0 0,0 0,0 7.321,7.321 19.189,7.321 26.51,0 C 7.32,19.189 7.32,7.32 0,0 m -75.023,-75.023 c -0.001,-0.001 -0.001,-0.001 -0.002,-0.002 l -18.74,-18.74 -0.002,0.001 c -0.011,-0.01 -0.019,-0.022 -0.03,-0.033 -7.321,-7.32 -19.189,-7.32 -26.51,0 -7.32,7.32 -7.32,19.189 0,26.509 0.011,0.011 0.023,0.02 0.034,0.031 l -0.002,0.001 18.742,18.742 c 0,0 0,0 0,0 4.898,4.898 11.827,6.501 18.073,4.845 l -20.84,-20.845 13.258,-13.258 20.854,20.86 c 1.673,-6.255 0.072,-13.204 -4.835,-18.111 M 13.258,39.781 c -14.646,14.646 -38.393,14.646 -53.039,0 -0.046,-0.046 -0.088,-0.095 -0.134,-0.141 L -58.537,21.024 v 0 c -0.004,-0.004 -0.007,-0.007 -0.011,-0.011 -12.355,-12.354 -14.288,-31.183 -5.8,-45.564 l -4.891,-4.892 c -14.381,8.488 -33.21,6.555 -45.565,-5.799 -0.046,-0.046 -0.088,-0.095 -0.133,-0.141 l -18.624,-18.616 h 0.001 c -0.004,-0.004 -0.008,-0.007 -0.011,-0.011 -14.647,-14.646 -14.647,-38.393 0,-53.039 14.646,-14.646 38.392,-14.646 53.039,0 0.134,0.135 0.258,0.275 0.39,0.411 l 18.1,18.093 c 0.091,0.09 0.187,0.173 0.277,0.264 12.36,12.359 14.289,31.2 5.788,45.583 l 4.883,4.885 c 14.384,-8.502 33.225,-6.573 45.585,5.787 0.134,0.135 0.258,0.275 0.39,0.411 l 18.099,18.092 c 0.092,0.09 0.187,0.174 0.278,0.265 14.647,14.646 14.647,38.392 0,53.039",
        "transform": "matrix(1.3333333,0,0,-1.3333333,280.2272,155.1564)"
      }
    ]
  },
  "Location": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "m 0,0 c -12.834,0 -23.238,-10.404 -23.238,-23.238 0,-12.835 10.404,-23.239 23.238,-23.239 12.834,0 23.238,10.404 23.238,23.239 C 23.238,-10.404 12.834,0 0,0",
        "transform": "matrix(1.3333333,0,0,-1.3333333,200,156.35373)"
      },
      {
        "d": "m 0,0 c -16.939,14.104 -47.003,44.076 -47.003,67.935 0,25.774 21.026,46.744 46.871,46.744 25.845,0 46.871,-20.97 46.871,-46.744 C 46.739,44.072 16.851,14.106 0,0 m -0.127,133.438 c -36.186,0 -65.625,-29.366 -65.625,-65.461 0,-36.099 43.1,-73.901 56.25,-84.539 H 9.274 c 13.061,10.617 56.224,48.437 56.224,84.539 0,36.095 -29.439,65.461 -65.625,65.461",
        "transform": "matrix(1.3333333,0,0,-1.3333333,200.16933,277.91787)"
      }
    ]
  },
  "Lock": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "m 159.375,140.625 h -18.75 V 112.5 h 18.75 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,0,400)"
      },
      {
        "d": "M 206.249,93.75 H 93.757 v 65.63 h 112.492 z m -56.287,112.538 c 17.634,0 32.419,-12.164 36.445,-28.556 h -72.89 c 4.026,16.392 18.81,28.556 36.445,28.556 m 55.572,-28.556 C 201.232,204.527 178.015,225 150.007,225 121.999,225 98.781,204.527 94.48,177.732 H 75 V 75 H 206.25 L 225,93.75 v 83.982 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,0,400)"
      }
    ]
  },
  "Mail": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "M 0,0 V 65.596 L 65.614,16.408 131.239,65.581 V 0 Z M 112.539,74.999 65.616,39.84 18.716,74.999 Z m 18.701,18.723 h -150 V -18.751 h 168.75 v 93.75 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,112.51307,249.9988)"
      }
    ]
  },
  "Manufacturing": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "m 0,0 c -7.262,0 -13.171,-5.91 -13.171,-13.173 0,-7.263 5.909,-13.172 13.171,-13.172 7.264,0 13.174,5.909 13.174,13.172 C 13.174,-5.91 7.264,0 0,0 m 0,-41.628 c -15.69,0 -28.455,12.765 -28.455,28.455 0,15.691 12.765,28.456 28.455,28.456 15.691,0 28.457,-12.765 28.457,-28.456 0,-15.69 -12.766,-28.455 -28.457,-28.455",
        "transform": "matrix(1.3333333,0,0,-1.3333333,199.9992,182.52827)"
      },
      {
        "d": "m 0,0 v -6.88 -9.464 l 8.782,-3.533 0.327,-0.133 c 0.21,-0.083 0.422,-0.165 0.629,-0.255 l 8.723,-3.748 6.713,6.715 4.858,4.857 10.807,-10.806 -4.858,-4.859 -6.716,-6.716 3.752,-8.726 c 0.091,-0.21 0.175,-0.422 0.259,-0.636 l 0.121,-0.302 3.528,-8.793 h 9.474 6.88 v -15.284 h -6.88 -9.477 l -3.527,-8.796 -0.117,-0.295 c -0.084,-0.21 -0.166,-0.423 -0.256,-0.63 l -3.764,-8.731 6.722,-6.722 4.859,-4.859 -10.807,-10.806 -4.858,4.858 -6.708,6.709 -8.72,-3.74 c -0.201,-0.086 -0.407,-0.167 -0.612,-0.248 L 8.774,-101.967 0,-105.503 v -9.459 -6.88 h -15.283 v 6.88 9.472 l -8.79,3.529 -0.313,0.125 c -0.213,0.085 -0.425,0.168 -0.635,0.259 l -8.724,3.747 -6.713,-6.714 -4.859,-4.858 -10.805,10.806 4.859,4.859 6.713,6.713 -3.748,8.723 c -0.089,0.208 -0.172,0.418 -0.256,0.628 l -0.131,0.329 -3.533,8.781 h -9.465 -6.88 v 15.284 h 6.88 9.462 l 3.534,8.778 0.142,0.352 c 0.08,0.203 0.159,0.404 0.244,0.603 l 3.751,8.724 -6.714,6.716 -4.858,4.859 10.807,10.806 4.857,-4.857 6.713,-6.715 8.724,3.748 c 0.207,0.09 0.418,0.172 0.627,0.255 l 0.329,0.133 8.782,3.533 V -6.88 0 Z M 14.01,14.01 H -29.293 V -6.88 c -0.42,-0.169 -0.843,-0.334 -1.259,-0.512 l -14.763,14.764 -30.621,-30.619 14.765,-14.765 c -0.178,-0.416 -0.342,-0.837 -0.512,-1.257 h -20.889 v -43.303 h 20.889 c 0.17,-0.421 0.334,-0.844 0.512,-1.259 l -14.765,-14.765 30.621,-30.619 14.765,14.765 c 0.415,-0.178 0.837,-0.342 1.257,-0.512 v -20.89 H 14.01 v 20.89 c 0.42,0.17 0.842,0.334 1.257,0.512 l 14.765,-14.765 30.62,30.619 -14.765,14.765 c 0.178,0.415 0.344,0.838 0.512,1.259 h 20.89 v 43.303 h -20.89 c -0.168,0.42 -0.334,0.841 -0.512,1.257 L 60.652,-23.247 30.032,7.372 15.268,-7.392 c -0.415,0.178 -0.838,0.343 -1.258,0.512 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,210.18893,118.86453)"
      }
    ]
  },
  "Marketing": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "M 0,0 -74.999,28.125 V 56.25 L 0,84.375 Z m -93.751,-18.753 h -0.002 c 0,-5.175 -4.196,-9.37 -9.371,-9.37 -5.175,0 -9.37,4.195 -9.37,9.37 V 9.375 h 18.743 z m -28.121,75.003 h 28.093 V 28.157 h -28.093 z m 149.998,9.375 h -9.375 v 18.75 L -0.071,103.125 -84.374,75 h -56.25 V 9.375 h 9.375 v -28.128 c 0,-15.533 12.592,-28.125 28.125,-28.125 15.533,0 28.125,12.592 28.125,28.124 l 0.003,0.001 V 6.249 L 0.001,-18.75 18.751,0 v 18.75 h 9.375 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,274.9984,237.49987)"
      }
    ]
  },
  "Mexico": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "M 215.625,107.813 H 187.5 v 84.375 h 28.125 z M 84.375,192.187 H 112.5 V 107.812 H 84.375 Z m 93.75,-84.374 h -56.25 v 84.375 h 56.25 z M 187.5,210.937 H 178.125 121.875 112.5 65.625 V 89.063 h 150 l 18.75,18.75 v 103.124 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,0,400)"
      },
      {
        "d": "m 0,0 c 7.767,0 14.063,6.296 14.063,14.063 0,7.766 -6.296,14.062 -14.063,14.062 -7.767,0 -14.063,-6.296 -14.063,-14.062 C -14.063,6.296 -7.767,0 0,0",
        "transform": "matrix(1.3333333,0,0,-1.3333333,200,218.75)"
      }
    ]
  },
  "Microphone": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "M 0,0 C 0,5.178 4.197,9.375 9.375,9.375 14.553,9.375 18.75,5.178 18.75,0 V -28.125 C 18.75,-33.303 14.553,-37.5 9.375,-37.5 4.197,-37.5 0,-33.303 0,-28.125 Z m 9.375,-56.25 c 15.533,0 28.125,12.592 28.125,28.125 V 0 C 37.5,15.533 24.908,28.125 9.375,28.125 -6.158,28.125 -18.75,15.533 -18.75,0 v -28.125 c 0,-15.533 12.592,-28.125 28.125,-28.125",
        "transform": "matrix(1.3333333,0,0,-1.3333333,187.5,137.5)"
      },
      {
        "d": "m 0,0 h -18.737 c -0.003,-20.708 -16.791,-37.495 -37.5,-37.495 -20.709,0 -37.498,16.787 -37.501,37.495 h -18.751 c 0,-27.869 20.274,-50.99 46.875,-55.453 v -19.542 h -18.75 v -18.75 h 56.25 v 18.75 h -18.75 v 19.544 C -20.269,-50.984 0,-27.865 0,0",
        "transform": "matrix(1.3333333,0,0,-1.3333333,274.98587,175.00693)"
      }
    ]
  },
  "Newspaper": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "M 187.5,121.846 H 84.221 v 84.413 H 187.5 Z m 37.5,65.782 h -9.375 -9.375 V 225 H 65.625 V 121.846 L 84.346,103.125 H 206.25 v 65.625 h 9.375 v -75 H 93.75 V 93.721 L 112.471,75 h 103.154 18.75 v 18.75 93.878 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,0,400)"
      },
      {
        "d": "m 168.792,159.375 h -28.167 v -18.75 h 28.167 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,0,400)"
      },
      {
        "d": "M 131.25,187.5 H 103.167 V 140.625 H 131.25 Z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,0,400)"
      },
      {
        "d": "M 168.76,187.5 H 140.625 V 168.75 H 168.76 Z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,0,400)"
      }
    ]
  },
  "Notebook": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "m 206.257,84.377 h -93.759 v 131.249 h 93.759 z M 93.75,234.375 V 197.006 H 75 v -18.881 h 18.75 v -18.75 H 75 V 140.494 H 93.75 V 121.94 H 75 V 103.06 H 93.75 V 65.625 h 112.5 L 225,84.377 v 149.998 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,0,400)"
      },
      {
        "d": "m 187.5,187.565 h -56.25 v -28.19 h 56.25 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,0,400)"
      }
    ]
  },
  "Odometer": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "m 0,0 h 18.75 c 0,17.331 -5.894,33.276 -15.766,45.976 L 16.67,59.662 3.412,72.92 -10.274,59.234 C -22.974,69.106 -38.919,75 -56.25,75 c -41.421,0 -75,-33.579 -75,-75 h 18.75 c 0,31.066 25.184,56.25 56.25,56.25 12.148,0 23.386,-3.864 32.581,-10.411 L -55.484,14.024 c -0.256,0.014 -0.508,0.039 -0.766,0.039 -7.766,0 -14.063,-6.297 -14.063,-14.063 0,-7.766 6.297,-14.063 14.063,-14.063 7.766,0 14.062,6.297 14.062,14.063 0,0.258 -0.024,0.511 -0.038,0.766 l 31.815,31.815 C -3.864,23.386 0,12.148 0,0",
        "transform": "matrix(1.3333333,0,0,-1.3333333,275,237.05587)"
      }
    ]
  },
  "OfficeBuilding": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "m 140.625,112.403 h 18.75 v 28.125 h -18.75 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,0,400)"
      },
      {
        "d": "m 140.625,149.903 h 18.75 v 28.125 h -18.75 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,0,400)"
      },
      {
        "d": "M 0,0 V 18.75 H -18.75 V 0 H -37.5 V 103.125 L 18.75,131.25 V 0 Z m 37.5,0 v 131.347 l -6.186,6.185 -3.092,3.093 -9.408,9.407 L -56.25,112.5 V 103.125 93.75 0 h -9.375 v -18.557 h 112.5 V 0 Z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,212.5,287.62893)"
      }
    ]
  },
  "PaperPlane": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "m 0,0 -9.411,28.165 37.705,37.46 z M -46.643,46.972 18.724,75.09 -18.812,37.54 Z M 46.877,103.125 -93.748,46.866 -28.123,18.75 -0.063,-46.875 56.252,93.75 Z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,224.99787,237.50027)"
      }
    ]
  },
  "Partnership": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "m 0,0 c -4.208,4.025 -9.909,6.502 -16.192,6.502 -6.283,0 -11.984,-2.477 -16.193,-6.502 -17.909,6.592 -30.683,23.804 -30.683,44.001 0,3.469 0.388,6.845 1.103,10.098 10.143,2.578 17.647,11.77 17.647,22.715 0,1.492 -0.146,2.95 -0.412,4.364 7.905,6.077 17.796,9.699 28.537,9.699 10.742,0 20.633,-3.622 28.538,-9.699 -0.266,-1.415 -0.412,-2.872 -0.412,-4.364 0,-10.945 7.504,-20.137 17.647,-22.715 0.715,-3.253 1.103,-6.629 1.103,-10.098 C 30.683,23.805 17.909,6.593 0,0 m -16.201,-21.623 c -0.968,0.002 -1.868,0.297 -2.614,0.802 -0.006,0.003 -0.01,0.008 -0.015,0.012 -0.243,0.166 -0.471,0.353 -0.678,0.56 -0.044,0.044 -0.077,0.098 -0.119,0.144 -0.161,0.174 -0.32,0.352 -0.453,0.549 -0.068,0.102 -0.115,0.217 -0.175,0.324 -0.089,0.156 -0.186,0.306 -0.257,0.472 -0.066,0.158 -0.104,0.329 -0.153,0.494 -0.039,0.13 -0.092,0.252 -0.12,0.386 -0.062,0.305 -0.095,0.621 -0.095,0.944 0,2.589 2.099,4.688 4.688,4.688 2.589,0 4.688,-2.099 4.688,-4.688 0,-0.323 -0.033,-0.639 -0.096,-0.944 -0.027,-0.134 -0.081,-0.256 -0.119,-0.386 -0.05,-0.165 -0.087,-0.336 -0.154,-0.494 -0.07,-0.166 -0.168,-0.316 -0.256,-0.472 -0.06,-0.107 -0.107,-0.222 -0.175,-0.324 -0.156,-0.231 -0.337,-0.443 -0.53,-0.643 -0.016,-0.015 -0.027,-0.034 -0.042,-0.05 -0.208,-0.208 -0.436,-0.395 -0.68,-0.561 -0.005,-0.004 -0.008,-0.008 -0.013,-0.011 -0.746,-0.505 -1.646,-0.8 -2.614,-0.802 -0.003,0 -0.006,-10e-4 -0.009,-10e-4 -0.003,0 -0.006,10e-4 -0.009,10e-4 M -70.86,80.303 v 0 c 0.207,0.184 0.429,0.35 0.664,0.497 0.005,0.003 0.011,0.005 0.016,0.008 0.227,0.14 0.466,0.261 0.716,0.362 0.072,0.028 0.148,0.044 0.221,0.069 0.194,0.066 0.388,0.132 0.592,0.173 0.29,0.056 0.588,0.09 0.895,0.09 2.589,0 4.688,-2.099 4.688,-4.688 0,-2.589 -2.099,-4.688 -4.688,-4.688 -2.589,0 -4.687,2.099 -4.687,4.688 0,0.259 0.036,0.507 0.076,0.754 0.039,0.211 0.09,0.418 0.152,0.62 0.255,0.828 0.724,1.553 1.355,2.115 M 39.983,77.569 c 0.04,-0.247 0.076,-0.496 0.076,-0.755 0,-2.589 -2.099,-4.688 -4.688,-4.688 -2.589,0 -4.688,2.099 -4.688,4.688 0,2.589 2.099,4.688 4.688,4.688 0.307,0 0.605,-0.034 0.896,-0.09 0.203,-0.041 0.397,-0.107 0.591,-0.173 0.073,-0.025 0.15,-0.041 0.222,-0.069 0.25,-0.101 0.49,-0.222 0.718,-0.363 0.004,-0.003 0.009,-0.005 0.014,-0.008 0.235,-0.146 0.457,-0.313 0.664,-0.497 v 0 c 0.63,-0.561 1.098,-1.286 1.354,-2.113 0.062,-0.202 0.113,-0.409 0.153,-0.62 m 18.825,-0.755 c 0,12.944 -10.493,23.438 -23.437,23.438 -4.571,0 -8.833,-1.313 -12.438,-3.576 -10.924,8.132 -24.459,12.951 -39.125,12.951 -14.666,0 -28.201,-4.819 -39.126,-12.951 -3.605,2.263 -7.867,3.576 -12.438,3.576 -12.944,0 -23.437,-10.494 -23.437,-23.438 0,-8.246 4.263,-15.493 10.701,-19.67 -0.864,-4.247 -1.325,-8.64 -1.325,-13.142 0,-27.987 17.526,-51.868 42.197,-61.302 0.195,-12.776 10.606,-23.073 23.428,-23.073 12.822,0 23.233,10.297 23.428,23.073 24.67,9.434 42.197,33.315 42.197,61.302 0,4.502 -0.461,8.895 -1.325,13.142 6.438,4.178 10.7,11.424 10.7,19.67",
        "transform": "matrix(1.3333333,0,0,-1.3333333,221.58947,246.16893)"
      }
    ]
  },
  "Partnership02": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "M 0,0 C -3.219,0 -6.361,0.326 -9.398,0.944 2.21,12.781 9.377,28.99 9.377,46.879 c 0,17.888 -7.165,34.095 -18.771,45.932 3.035,0.618 6.176,0.943 9.394,0.943 25.89,0 46.877,-20.987 46.877,-46.877 C 46.877,20.988 25.89,0 0,0 m -56.25,0 c -25.889,0 -46.877,20.988 -46.877,46.877 0,25.89 20.988,46.877 46.877,46.877 3.219,0 6.362,-0.325 9.398,-0.943 -11.606,-11.837 -18.771,-28.045 -18.771,-45.932 0,-17.889 7.167,-34.097 18.775,-45.935 C -49.886,0.326 -53.03,0 -56.25,0 m 46.877,46.877 c 0,-15.336 -7.366,-28.951 -18.752,-37.503 -11.386,8.552 -18.752,22.167 -18.752,37.503 0,15.337 7.366,28.951 18.752,37.503 11.386,-8.552 18.752,-22.166 18.752,-37.503 m 9.375,65.627 c -10.066,0 -19.599,-2.273 -28.125,-6.324 -8.525,4.051 -18.058,6.324 -28.125,6.324 -36.243,0 -65.625,-29.381 -65.625,-65.625 0,-36.243 29.382,-65.625 65.625,-65.625 10.067,0 19.6,2.274 28.125,6.324 8.526,-4.05 18.059,-6.324 28.125,-6.324 36.244,0 65.625,29.382 65.625,65.625 0,36.244 -29.381,65.625 -65.625,65.625",
        "transform": "matrix(1.3333333,0,0,-1.3333333,237.49707,262.50573)"
      }
    ]
  },
  "People": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "m 0,0 c 7.744,0 14.045,-6.3 14.045,-14.043 0,-7.744 -6.301,-14.044 -14.045,-14.044 -7.743,0 -14.043,6.3 -14.043,14.044 C -14.043,-6.3 -7.743,0 0,0 m 0,-46.837 c 18.083,0 32.795,14.711 32.795,32.794 C 32.795,4.039 18.083,18.75 0,18.75 c -18.082,0 -32.793,-14.711 -32.793,-32.793 0,-18.083 14.711,-32.794 32.793,-32.794",
        "transform": "matrix(1.3333333,0,0,-1.3333333,249.98013,125.15947)"
      },
      {
        "d": "M 0,0 H -93.75 V 4.968 L -49.891,37.5 h 6.032 L 0,4.971 Z M -56.25,56.25 -112.5,14.414 V -18.75 H 18.75 V 14.411 L -37.5,56.25 Z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,212.5,275)"
      },
      {
        "d": "m 0,0 c 7.744,0 14.045,-6.3 14.045,-14.043 0,-7.744 -6.301,-14.044 -14.045,-14.044 -7.743,0 -14.043,6.3 -14.043,14.044 C -14.043,-6.3 -7.743,0 0,0 m 0,-46.837 c 18.083,0 32.795,14.711 32.795,32.794 C 32.795,4.039 18.083,18.75 0,18.75 c -18.082,0 -32.793,-14.711 -32.793,-32.793 0,-18.083 14.711,-32.794 32.793,-32.794",
        "transform": "matrix(1.3333333,0,0,-1.3333333,149.98013,125.15947)"
      },
      {
        "d": "m 0,0 h -18.75 l -12.342,-9.18 15.779,-11.737 2.922,2.167 h 6.032 L 37.5,-51.279 V -56.25 H 0 V -75 h 56.25 v 33.161 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,262.5,200)"
      }
    ]
  },
  "Person": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "M 0,0 H 93.75 V 4.971 L 49.891,37.5 H 43.859 L 0,4.968 Z M 112.5,-18.75 H -18.75 V 14.414 L 37.5,56.25 H 56.25 L 112.5,14.411 Z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,137.5,275)"
      },
      {
        "d": "m 0,0 c -7.743,0 -14.043,-6.3 -14.043,-14.043 0,-7.744 6.3,-14.044 14.043,-14.044 7.744,0 14.045,6.3 14.045,14.044 C 14.045,-6.3 7.744,0 0,0 m 0,-46.837 c -18.082,0 -32.793,14.711 -32.793,32.794 0,18.082 14.711,32.793 32.793,32.793 18.083,0 32.795,-14.711 32.795,-32.793 0,-18.083 -14.712,-32.794 -32.795,-32.794",
        "transform": "matrix(1.3333333,0,0,-1.3333333,199.98013,125.15947)"
      }
    ]
  },
  "Phillippines": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "M 0,0 C 5.178,0 9.375,4.197 9.375,9.375 9.375,14.553 5.178,18.75 0,18.75 -5.178,18.75 -9.375,14.553 -9.375,9.375 -9.375,4.197 -5.178,0 0,0",
        "transform": "matrix(1.3333333,0,0,-1.3333333,143.40493,212.5)"
      },
      {
        "d": "m 0,0 h -63.683 l -37.5,37.5 H 0 Z m 0,-46.875 h -101.183 l 37.5,37.5 H 0 Z M -131.25,37.5 h 16.808 l 42.188,-42.187 -42.188,-42.188 H -131.25 Z M -150,56.25 V -65.625 H 0 l 18.75,18.75 V 56.25 Z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,287.5,193.75)"
      }
    ]
  },
  "Phone": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "m 0,0 h -74.889 v 131.292 h 18.715 v -9.346 h 37.413 v 9.346 H 0 Z m 9.451,150.071 h -93.809 l -9.316,-9.363 V -9.304 l 9.375,-9.375 h 93.75 l 9.375,9.375 v 150 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,249.89907,287.59467)"
      },
      {
        "d": "m 131.25,93.75 h 37.5 v 9.375 h -37.5 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,0,400)"
      }
    ]
  },
  "PieChart": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "M 0,0 V 24.234 C 10.819,19.506 19.506,10.819 24.234,0 Z M -18.75,46.875 V 28.146 0 -9.375 l 9.267,-9.326 -0.034,-0.058 H 0 v 0.009 h 28.146 v -0.009 h 18.729 v 0.009 c 0,36.244 -29.381,65.625 -65.625,65.625",
        "transform": "matrix(1.3333333,0,0,-1.3333333,237.5,162.5)"
      },
      {
        "d": "m 0,0 c -4.342,-21.415 -23.271,-37.536 -45.968,-37.536 -25.905,0 -46.906,21.001 -46.906,46.906 0,22.698 16.123,41.629 37.541,45.969 V 9.37 L -45.958,0 Z m -36.583,75.005 h -9.375 c -36.244,0 -65.625,-29.382 -65.625,-65.625 0,-36.244 29.381,-65.625 65.625,-65.625 36.24,0 65.619,29.376 65.625,65.615 v 9.371 h -56.25 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,248.778,225.00613)"
      }
    ]
  },
  "Piggybank": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "M 0,0 C -17.474,0 -32.156,11.951 -36.318,28.125 H -56.25 v 18.75 h 19.932 C -32.156,63.049 -17.474,75 0,75 20.711,75 37.5,58.211 37.5,37.5 37.5,16.789 20.711,0 0,0 M 75,46.875 H 55.458 C 50.992,73.476 27.87,93.75 0,93.75 c -4.008,0 -7.916,-0.424 -11.686,-1.221 L -18.75,103.125 -31.385,84.173 C -38.47,79.394 -44.411,73.046 -48.706,65.625 H -75 V 9.375 h 26.294 c 2.992,-5.171 6.785,-9.819 11.206,-13.781 v -23.719 h 18.75 v 12.582 c 5.864,-2.075 12.174,-3.207 18.75,-3.207 6.576,0 12.884,1.139 18.75,3.213 V -28.125 H 37.5 v 23.709 c 9.297,8.324 15.801,19.693 17.958,32.541 H 75 Z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,200,274.95813)"
      },
      {
        "d": "m 136.155,150.031 h 27.689 v 9.375 h -27.689 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,0,400)"
      },
      {
        "d": "m 0,0 c 2.59,0 4.689,-2.099 4.689,-4.689 0,-2.59 -2.099,-4.689 -4.689,-4.689 -2.59,0 -4.689,2.099 -4.689,4.689 C -4.689,-2.099 -2.59,0 0,0 m 0,-23.376 c 10.321,0 18.687,8.366 18.687,18.687 0,10.32 -8.366,18.687 -18.687,18.687 -10.321,0 -18.687,-8.367 -18.687,-18.687 0,-10.321 8.366,-18.687 18.687,-18.687",
        "transform": "matrix(1.3333333,0,0,-1.3333333,199.99547,106.20587)"
      }
    ]
  },
  "Plus": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "m 0,0 c -31.051,0 -56.223,25.172 -56.223,56.223 0,31.051 25.172,56.223 56.223,56.223 31.051,0 56.223,-25.172 56.223,-56.223 C 56.223,25.172 31.051,0 0,0 m 0,131.223 c -41.421,0 -75,-33.579 -75,-75 0,-41.421 33.579,-75 75,-75 41.421,0 75,33.579 75,75 0,41.421 -33.579,75 -75,75",
        "transform": "matrix(1.3333333,0,0,-1.3333333,200,274.96373)"
      },
      {
        "d": "M 0,0 H -18.75 V -18.75 H -37.499 V -37.5 H -18.75 V -56.25 H 0 v 18.75 h 18.75 v 18.75 H 0 Z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,212.5,162.5)"
      }
    ]
  },
  "Pulse": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "m 0,0 -19.124,-18.749 -56.25,56.25 -37.5,-37.507 h -18.75 v -18.75 h 28.125 l 28.125,28.132 56.25,-56.25 28.125,28.118 h 9.365 l 0,18.756 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,275.49867,193.75133)"
      }
    ]
  },
  "Recruitment": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "m 0,0 h -14.062 l -0.001,14.062 h -18.75 L -32.812,0 h -14.063 v -18.75 h 14.063 v -14.063 h 18.75 V -18.75 H 0 Z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,300,175)"
      },
      {
        "d": "M 0,0 H -93.75 V 4.968 L -49.891,37.5 h 6.032 L 0,4.971 Z M -56.25,56.25 -112.5,14.414 V -18.75 H 18.75 V 14.411 L -37.5,56.25 Z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,250,275)"
      },
      {
        "d": "m 0,0 c 7.744,0 14.045,-6.3 14.045,-14.043 0,-7.744 -6.301,-14.044 -14.045,-14.044 -7.743,0 -14.043,6.3 -14.043,14.044 C -14.043,-6.3 -7.743,0 0,0 m 0,-46.837 c 18.083,0 32.795,14.711 32.795,32.794 C 32.795,4.039 18.083,18.75 0,18.75 c -18.082,0 -32.793,-14.711 -32.793,-32.793 0,-18.083 14.711,-32.794 32.793,-32.794",
        "transform": "matrix(1.3333333,0,0,-1.3333333,187.48,125.15947)"
      }
    ]
  },
  "Reload": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "m 0,0 v -18.75 h 13.791 c -10.3,-11.504 -25.259,-18.75 -41.916,-18.75 -31.066,0 -56.25,25.184 -56.25,56.25 0,31.066 25.184,56.25 56.25,56.25 31.066,0 56.25,-25.184 56.25,-56.25 h 18.75 c 0,41.421 -33.579,75 -75,75 -41.421,0 -75,-33.579 -75,-75 0,-41.421 33.579,-75 75,-75 22.407,0 42.504,9.838 56.242,25.419 v -16.082 h 18.75 V -9.375 L 37.492,0 Z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,237.5,225)"
      }
    ]
  },
  "Sales": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "m 168.758,75 h 18.75 v 65.625 h -18.75 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,0,400)"
      },
      {
        "d": "m 196.875,75 h 18.75 v 84.375 h -18.75 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,0,400)"
      },
      {
        "d": "m 112.5,75 h 18.75 v 65.548 H 112.5 Z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,0,400)"
      },
      {
        "d": "m 140.618,75 h 18.75 v 46.859 h -18.75 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,0,400)"
      },
      {
        "d": "m 84.375,75 h 18.75 v 37.471 h -18.75 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,0,400)"
      },
      {
        "d": "m 0,0 h -37.492 v -18.75 h 14.86 l -42.985,-42.984 -28.058,28.126 -44.205,-44.216 13.26,-13.256 30.932,30.938 28.055,-28.125 56.258,56.259 v -14.905 h 18.75 v 37.538 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,287.5,100)"
      }
    ]
  },
  "Scissors": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "m 0,0 c -5.178,0 -9.375,4.197 -9.375,9.375 0,5.178 4.197,9.375 9.375,9.375 5.178,0 9.375,-4.197 9.375,-9.375 C 9.375,4.197 5.178,0 0,0 m -56.25,-56.25 c -5.178,0 -9.375,4.197 -9.375,9.375 0,5.178 4.197,9.375 9.375,9.375 5.178,0 9.375,-4.197 9.375,-9.375 0,-5.178 -4.197,-9.375 -9.375,-9.375 M 0,37.5 c -12.245,0 -22.657,-7.828 -26.518,-18.75 H -46.875 V 75 h -18.75 V 18.75 h -56.25 V 0 h 56.25 v -20.357 c -10.922,-3.861 -18.75,-14.273 -18.75,-26.518 0,-15.533 12.592,-28.125 28.125,-28.125 15.533,0 28.125,12.592 28.125,28.125 0,12.245 -7.828,22.657 -18.75,26.518 V 0 h 20.357 C -22.657,-10.922 -12.245,-18.75 0,-18.75 15.533,-18.75 28.125,-6.158 28.125,9.375 28.125,24.908 15.533,37.5 0,37.5",
        "transform": "matrix(1.3333333,0,0,-1.3333333,262.5,200)"
      }
    ]
  },
  "Search": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "M 0,0 C -25.888,0 -46.875,20.987 -46.875,46.875 -46.875,72.763 -25.888,93.75 0,93.75 25.888,93.75 46.875,72.763 46.875,46.875 46.875,20.987 25.888,0 0,0 M 54.872,10.893 C 61.663,21.227 65.625,33.585 65.625,46.875 65.625,83.119 36.244,112.5 0,112.5 c -36.244,0 -65.625,-29.381 -65.625,-65.625 0,-36.244 29.381,-65.625 65.625,-65.625 13.326,0 25.716,3.983 36.067,10.808 l 29.558,-29.558 18.75,18.75 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,187.5,250)"
      }
    ]
  },
  "Skyline": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "m 103.125,112.5 h 18.75 v 28.125 h -18.75 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,0,400)"
      },
      {
        "d": "m 178.125,112.5 h 18.75 v 28.125 h -18.75 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,0,400)"
      },
      {
        "d": "m 103.125,150 h 18.75 v 28.125 h -18.75 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,0,400)"
      },
      {
        "d": "M 0,0 V 18.75 H -18.75 V 0 H -37.5 V 65.625 H 18.75 V 0 Z M -75,0 V 18.75 H -93.75 V 0 h -18.75 v 103.125 l 56.25,28.125 V 0 Z M 37.5,0 V 65.625 L 28.125,75 18.75,84.375 H -37.5 v 46.875 l -6.25,6.25 -3.125,3.125 -9.375,9.375 -75,-37.5 V 103.125 93.75 0 h -9.375 v -18.75 h 187.5 V 0 Z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,262.5,287.5)"
      }
    ]
  },
  "SoftwareDevelopment": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "M 0,0 -18.758,-9.373 -37.516,0 V 28.125 L -18.758,37.536 0,28.125 Z m 18.742,37.5 -37.5,18.75 -37.5,-18.75 V -9.375 l 37.5,-18.75 37.5,18.75 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,225.0104,168.66293)"
      },
      {
        "d": "M 0,0 -18.758,-9.373 -37.516,0 V 28.125 L -18.758,37.536 0,28.125 Z M -18.758,56.25 -56.258,37.5 V -9.375 l 37.5,-18.75 37.5,18.75 V 37.5 Z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,281.2604,268.75)"
      },
      {
        "d": "M 0,0 -18.758,-9.373 -37.516,0 V 28.125 L -18.758,37.536 0,28.125 Z M -56.258,37.5 V -9.375 l 37.5,-18.75 37.5,18.75 V 37.5 l -37.5,18.75 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,168.7604,268.75)"
      }
    ]
  },
  "Star": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "M 0,0 28.517,-20.719 17.625,12.805 46.142,33.523 H 10.893 L 10e-4,67.047 -10.892,33.523 H -46.141 L -17.623,12.805 -28.517,-20.718 Z M 56.206,-45.263 H 30.399 L 0,-23.176 -30.399,-45.263 h -25.807 l 16.54,50.906 -35.34,25.676 v 20.954 h 50.491 L -9.857,97.385 H 9.858 L 24.516,52.273 H 74.994 V 31.311 L 39.666,5.643 Z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,200.00787,234.748)"
      }
    ]
  },
  "Strategy": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "m 0,0 c -5.184,0 -9.385,4.202 -9.385,9.386 0,5.183 4.201,9.385 9.385,9.385 5.184,0 9.386,-4.202 9.386,-9.385 C 9.386,4.202 5.184,0 0,0 m 0.044,37.555 c -15.533,0 -28.125,-12.592 -28.125,-28.125 0,-15.533 12.592,-28.125 28.125,-28.125 15.534,0 28.125,12.592 28.125,28.125 0,15.533 -12.591,28.125 -28.125,28.125",
        "transform": "matrix(1.3333333,0,0,-1.3333333,137.4408,150.0732)"
      },
      {
        "d": "M 0,0 -13.258,13.258 -27.927,-1.411 -42.732,13.395 -55.99,0.137 l 14.805,-14.805 -14.669,-14.669 13.258,-13.258 14.669,14.669 14.806,-14.805 13.258,13.257 -14.806,14.806 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,299.64453,242.73053)"
      },
      {
        "d": "m 75,112.5 h 18.75 v 18.75 H 75 Z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,0,400)"
      },
      {
        "d": "m 103.091,112.5 h 18.75 v 18.75 h -18.75 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,0,400)"
      },
      {
        "d": "M 0,0 -12.531,-13.947 1.255,-25.549 h -35.586 -18.75 v -18.695 -37.5 h -9.375 v -18.75 h 9.375 9.375 9.375 v 56.25 H 1.596 l -13.838,-11.623 12.523,-13.955 30.967,25.578 0.004,18.695 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,258.2748,116.0084)"
      }
    ]
  },
  "SupplyChain": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "m 0,0 h -46.905 v 46.932 h 14.102 V 28.285 h 18.702 V 46.932 H 0 Z m -65.607,0 h -46.886 v 46.932 h 14.092 V 28.285 h 18.702 v 18.647 h 14.092 z m -14.074,112.527 h 14.074 V 93.698 h 18.702 v 18.829 h 14.083 v -46.57 h -46.859 z m 65.598,-46.799 v 65.573 H -98.419 V 65.728 h -32.824 V -18.751 H 18.764 v 84.479 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,274.99093,274.9992)"
      }
    ]
  },
  "Target": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "m 0,0 c -36.244,0 -65.625,29.381 -65.625,65.625 0,36.244 29.381,65.625 65.625,65.625 36.244,0 65.625,-29.381 65.625,-65.625 C 65.625,29.381 36.244,0 0,0 m 0,150 c -46.599,0 -84.375,-37.776 -84.375,-84.375 0,-46.599 37.776,-84.375 84.375,-84.375 46.599,0 84.375,37.776 84.375,84.375 C 84.375,112.224 46.599,150 0,150",
        "transform": "matrix(1.3333333,0,0,-1.3333333,200,287.5)"
      },
      {
        "d": "m 0,0 c -15.533,0 -28.124,12.592 -28.124,28.124 0,15.533 12.591,28.125 28.124,28.125 15.533,0 28.124,-12.592 28.124,-28.125 C 28.124,12.592 15.533,0 0,0 m 0.001,75 c -25.889,0 -46.875,-20.987 -46.875,-46.875 0,-25.888 20.986,-46.875 46.875,-46.875 25.888,0 46.875,20.987 46.875,46.875 C 46.876,54.013 25.889,75 0.001,75",
        "transform": "matrix(1.3333333,0,0,-1.3333333,199.9992,237.5)"
      },
      {
        "d": "m 0,0 c -5.178,0 -9.375,-4.197 -9.375,-9.375 0,-5.178 4.197,-9.375 9.375,-9.375 5.178,0 9.375,4.197 9.375,9.375 C 9.375,-4.197 5.178,0 0,0",
        "transform": "matrix(1.3333333,0,0,-1.3333333,200.0048,187.50467)"
      }
    ]
  },
  "Tech": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "m 187.5,112.5 h -75 v 75 h 75 z m 37.5,56.25 v 18.75 h -18.75 v 9.375 l -9.375,9.375 H 187.5 V 225 h -18.75 v -18.75 h -9.375 V 225 h -18.75 V 206.25 H 131.25 V 225 H 112.5 v -18.75 h -9.375 L 93.75,196.875 V 187.5 H 75 v -18.75 h 18.75 v -9.375 H 75 v -18.75 H 93.75 V 131.25 H 75 V 112.5 h 18.75 v -9.375 l 9.375,-9.375 H 112.5 V 75 h 18.75 v 18.75 h 9.375 V 75 h 18.75 v 18.75 h 9.375 V 75 h 18.75 v 18.75 h 9.342 l 9.408,9.375 V 112.5 H 225 v 18.75 h -18.75 v 9.375 H 225 v 18.75 h -18.75 v 9.375 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,0,400)"
      },
      {
        "d": "M 0,0 H 18.75 V 18.794 L 9.375,28.169 -9.291,28.17 V 9.42 L 0,9.42 Z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,212.388,199.9988)"
      }
    ]
  },
  "Testimonial": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "m 0,0 h -56.117 c -31,0 -56.219,25.22 -56.219,56.219 0,30.999 25.219,56.218 56.219,56.218 30.999,0 56.219,-25.219 56.219,-56.185 z m -56.117,131.187 c -41.404,0 -74.969,-33.564 -74.969,-74.968 0,-41.405 33.565,-74.969 74.969,-74.969 h 74.833 l 0.136,74.969 c 0,41.404 -33.565,74.968 -74.969,74.968",
        "transform": "matrix(1.3333333,0,0,-1.3333333,274.87493,274.91627)"
      },
      {
        "d": "m 0,0 -9.375,-9.375 v -18.75 h 18.75 v 18.75 L 18.789,0 Z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,174.94787,181.25)"
      },
      {
        "d": "M 0,0 V -18.75 H 18.75 V 0 l 9.414,9.375 H 9.375 Z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,200,193.75)"
      }
    ]
  },
  "Timer": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "M 0,0 -12.192,12.193 -18.778,5.608 -6.586,-6.586 Z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,287.53707,141.25773)"
      },
      {
        "d": "m 0,0 c -25.875,0 -46.852,20.976 -46.852,46.852 0,25.875 20.977,46.851 46.852,46.851 25.875,0 46.852,-20.976 46.852,-46.851 C 46.852,20.976 25.875,0 0,0 m 4.72,112.208 -10e-4,9.624 h 4.656 v 9.314 h -18.75 v -9.314 h 4.779 l 0.001,-9.614 c -34.097,-2.361 -61.03,-30.75 -61.03,-65.447 0,-36.244 29.381,-65.625 65.625,-65.625 36.244,0 65.625,29.381 65.625,65.625 0,34.655 -26.867,63.016 -60.905,65.437",
        "transform": "matrix(1.3333333,0,0,-1.3333333,200,274.86093)"
      },
      {
        "d": "m 0,0 h -18.75 v -28.125 l 9.375,-9.335 H 18.75 v 18.67 H 0 Z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,212.5,175)"
      }
    ]
  },
  "Toolbox": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "m 0,0 v 37.548 h 46.813 v -9.375 h 18.75 v 9.375 h 46.906 V 0 Z M 112.469,84.403 V 56.298 H 65.563 v 9.375 H 46.813 V 56.298 H 0 v 28.105 z m -84.406,28.145 h 56.291 v -9.375 H 28.063 Z m 84.389,-9.375 h -9.389 v 18.75 l -9.375,9.375 h -75 l -9.375,-9.375 v -18.75 H -0.174 L -18.812,84.403 V -18.702 h 150 V 84.403 Z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,125.082,275.06333)"
      }
    ]
  },
  "TransportationAndLogistics": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "m 0,0 c -31.017,0 -56.253,25.235 -56.253,56.253 0,31.018 25.236,56.253 56.253,56.253 31.018,0 56.252,-25.235 56.252,-56.253 C 56.252,25.235 31.018,0 0,0 m -0.087,131.34 c -41.355,0 -75,-33.645 -75,-75 0,-41.356 33.645,-75 75,-75 41.355,0 74.999,33.644 74.999,75 0,41.355 -33.644,75 -74.999,75",
        "transform": "matrix(1.3333333,0,0,-1.3333333,199.99413,275.1204)"
      },
      {
        "d": "M 0,0 15.491,-15.49 H -33.516 -33.83 V -34.22 H 15.512 L 0,-49.732 11.825,-61.558 41.163,-30.779 v 11.827 L 11.825,11.827 Z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,195.1068,166.8464)"
      }
    ]
  },
  "Tree": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "M 0,0 V 17.906 L 28.125,46.031 18.75,55.406 0,36.656 V 64.781 H -18.75 V 28.017 L -36.764,46.031 -46.139,36.656 -18.75,9.267 V 0 c -21.392,4.343 -37.494,23.255 -37.494,45.929 0,25.886 20.984,46.869 46.869,46.869 25.885,0 46.869,-20.983 46.869,-46.869 C 37.494,23.255 21.392,4.343 0,0 m 56.351,45.929 c 0,36.3 -29.426,65.727 -65.726,65.727 -36.3,0 -65.726,-29.427 -65.726,-65.727 0,-33.115 24.494,-60.497 56.351,-65.049 V -38.344 H 0 v 19.224 c 31.857,4.552 56.351,31.934 56.351,65.049",
        "transform": "matrix(1.3333333,0,0,-1.3333333,212.5,248.87413)"
      }
    ]
  },
  "USA": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "m 84.375,117.188 h 131.25 v -9.375 H 84.375 Z M 150,173.437 h 65.625 v -9.375 H 150 Z M 84.375,145.312 v 9.375 h 60.763 4.862 65.625 v -9.375 z m 0,-9.375 h 131.25 v -9.375 H 84.375 Z m 131.25,46.875 H 150 v 9.375 h 65.625 z M 150,210.937 H 75 65.625 V 89.063 h 150 l 18.75,18.75 v 103.124 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,0,400)"
      }
    ]
  },
  "Umbrella": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "M 0,0 C 27.873,0 50.997,-20.274 55.467,-46.876 H -55.467 C -50.997,-20.274 -27.873,0 0,0 m 74.944,-56.205 c 0,41.421 -33.579,75 -75,75 -41.417,0 -74.993,-33.572 -75,-74.988 l -0.012,-0.012 v -9.38 h 65.637 v -37.495 h 0.004 c 0,-0.003 0,-0.006 0,-0.008 0,-5.176 -4.196,-9.372 -9.372,-9.372 -5.176,0 -9.372,4.196 -9.372,9.372 0,0.002 10e-4,0.005 10e-4,0.008 h -18.761 c 0,-15.533 12.592,-28.125 28.125,-28.125 15.533,0 28.125,12.592 28.125,28.125 v 37.495 h 65.625 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,200.07493,125.05947)"
      }
    ]
  },
  "Unlock": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "m 159.375,131.25 h -18.75 v -28.125 h 18.75 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,0,400)"
      },
      {
        "d": "M 206.249,84.375 H 93.757 v 65.63 h 112.492 z m 0.001,84.375 v 9.377 0 c -0.001,31.065 -25.185,56.248 -56.25,56.248 -25.384,0 -46.834,-16.818 -53.833,-39.917 l 6.958,-6.958 h 10.553 c 4.162,16.176 18.845,28.128 36.32,28.128 20.712,0 37.502,-16.79 37.502,-37.501 0,-0.001 0,-0.001 0,-0.002 v 0 -9.375 H 75 V 65.625 H 205.611 L 225,84.375 v 84.375 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,0,400)"
      }
    ]
  },
  "WarehousingAndDistribution": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "m 0,0 h -93.75 v 75 l 37.49,37.5 H -37.5 L 0,75 Z m -28.125,131.301 h -37.5 L -112.516,84.375 V -18.75 H 18.766 V 84.375 Z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,262.5,275)"
      },
      {
        "d": "m 159.375,112.5 h 18.75 v 18.75 h -18.75 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,0,400)"
      },
      {
        "d": "m 121.875,112.5 h 18.75 v 18.75 h -18.75 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,0,400)"
      },
      {
        "d": "m 140.625,131.25 h 18.75 V 150 h -18.75 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,0,400)"
      }
    ]
  },
  "Watch": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "m 187.5,103.094 h -74.984 v 93.798 H 187.5 Z m 0,112.531 h -9.375 v 18.854 h -56.25 v -18.854 h -9.399 L 93.75,196.875 V 103.094 L 112.5,84.375 h 9.375 v -18.75 h 56.25 v 18.75 h 9.375 l 18.75,18.75 v 93.766 z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,0,400)"
      },
      {
        "d": "M 0,0 H 18.75 V 18.75 H 0 V 46.875 H -18.75 V 9.375 L -9.375,0 Z",
        "transform": "matrix(1.3333333,0,0,-1.3333333,212.5,212.5)"
      }
    ]
  },
  "World": {
    "container": "M 0,0 H 300 V 300 H 0 Z",
    "containerTransform": "matrix(1.3333333,0,0,-1.3333333,0,400)",
    "icon": [
      {
        "d": "m 0,0 c -3.449,1.864 -7.243,3.519 -11.335,4.923 2.055,7.361 3.339,15.496 3.686,24.085 H 10.997 C 10.103,18.18 6.157,8.218 0,0 m -21.52,-17.398 c 2.783,3.929 5.236,8.538 7.281,13.686 2.889,-0.948 5.595,-2.024 8.081,-3.215 -4.478,-4.288 -9.661,-7.841 -15.362,-10.471 m -18.836,-4.364 V 0.776 c 6.096,-0.253 11.913,-0.988 17.3,-2.134 -4.228,-10.596 -10.327,-18.063 -17.3,-20.404 m 0,50.77 h 23.333 c -0.32,-7.735 -1.418,-15.025 -3.144,-21.555 -6.3,1.478 -13.084,2.416 -20.189,2.703 z m 0,28.228 c 7.105,0.287 13.889,1.225 20.189,2.702 1.726,-6.53 2.824,-13.819 3.144,-21.555 h -23.333 z m 0,31.917 c 6.973,-2.34 13.072,-9.808 17.3,-20.403 -5.387,-1.147 -11.204,-1.882 -17.3,-2.134 z M -6.158,74.318 c -2.486,-1.19 -5.192,-2.266 -8.081,-3.214 -2.045,5.147 -4.498,9.757 -7.281,13.685 5.701,-2.629 10.883,-6.182 15.362,-10.471 M 10.997,38.383 H -7.649 c -0.347,8.59 -1.631,16.725 -3.686,24.086 4.092,1.404 7.886,3.059 11.335,4.923 6.157,-8.218 10.103,-18.18 10.997,-29.009 m -60.728,28.233 c -6.096,0.252 -11.913,0.987 -17.3,2.134 4.228,10.595 10.327,18.062 17.3,20.403 z m 0,-28.233 h -23.333 c 0.32,7.736 1.418,15.025 3.144,21.556 6.3,-1.478 13.084,-2.416 20.189,-2.703 z m 0,-28.227 C -56.836,9.869 -63.62,8.931 -69.92,7.453 c -1.726,6.53 -2.824,13.82 -3.144,21.555 h 23.333 z m 0,-31.918 c -6.973,2.341 -13.072,9.808 -17.3,20.404 5.387,1.146 11.204,1.881 17.3,2.134 z m -34.198,14.835 c 2.486,1.191 5.192,2.267 8.081,3.215 2.045,-5.148 4.498,-9.757 7.281,-13.686 -5.701,2.63 -10.883,6.183 -15.362,10.471 m -17.155,35.935 h 18.646 c 0.347,-8.589 1.631,-16.724 3.687,-24.085 C -82.844,3.519 -86.637,1.864 -90.087,0 c -6.157,8.218 -10.103,18.18 -10.997,29.008 m 10.997,38.384 c 3.45,-1.864 7.243,-3.519 11.336,-4.923 -2.056,-7.361 -3.34,-15.496 -3.687,-24.086 h -18.646 c 0.894,10.829 4.84,20.791 10.997,29.009 m 21.52,17.397 c -2.783,-3.928 -5.236,-8.538 -7.281,-13.685 -2.889,0.948 -5.595,2.024 -8.081,3.214 4.479,4.289 9.661,7.842 15.362,10.471 m 23.524,23.907 c -41.422,0 -75,-33.579 -75,-75 0,-41.422 33.578,-75 75,-75 41.421,0 75,33.578 75,75 0,41.421 -33.579,75 -75,75",
        "transform": "matrix(1.3333333,0,0,-1.3333333,260.058,244.92773)"
      }
    ]
  }
};

export const lsgIconCategories = {
  "business": [
    "BrandAmbassador",
    "Careers",
    "Endorsement",
    "FinancialInsurance",
    "FinancialServices",
    "Insurance",
    "Insurance02",
    "Investment",
    "Leadership",
    "Marketing",
    "Partnership",
    "Partnership02",
    "Recruitment",
    "Sales",
    "Strategy",
    "Testimonial"
  ],
  "technology": [
    "AI",
    "Browser",
    "Cloud",
    "ComputerMonitor",
    "FullstackDevelopment",
    "SoftwareDevelopment",
    "Tech"
  ],
  "communication": [
    "ChatBubble",
    "Conversation",
    "CustomerSupport",
    "HelpDeskService",
    "Mail",
    "Microphone",
    "PaperPlane",
    "Phone"
  ],
  "locations": [
    "Colombia",
    "Globe",
    "Guatemala",
    "Location",
    "Mexico",
    "OfficeBuilding",
    "Phillippines",
    "Skyline",
    "USA",
    "World"
  ],
  "time": [
    "AlarmClock",
    "Calendar",
    "Clock",
    "Cycle",
    "Timer",
    "Watch"
  ],
  "actions": [
    "Checklist",
    "Cross",
    "Link",
    "Lock",
    "Plus",
    "Reload",
    "Scissors",
    "Search",
    "Toolbox",
    "Unlock"
  ],
  "objects": [
    "Award",
    "Battery",
    "Bullseye",
    "Coffee",
    "Document",
    "Folder",
    "Funnel",
    "Goal",
    "Heart",
    "Image",
    "Information",
    "Lifesaver",
    "Lightbulb",
    "Newspaper",
    "Notebook",
    "Pulse",
    "Star",
    "Target",
    "Tree",
    "Umbrella"
  ],
  "people": [
    "People",
    "Person"
  ],
  "finance": [
    "Calculator",
    "Coin",
    "Coins",
    "Odometer",
    "PieChart",
    "Piggybank"
  ],
  "industries": [
    "DataScience",
    "FoodAndBeverage",
    "GlobalForwarding",
    "HealthInsurance",
    "Manufacturing",
    "SupplyChain",
    "TransportationAndLogistics",
    "WarehousingAndDistribution"
  ]
};

export const lsgIconNames = [
  "AI",
  "AlarmClock",
  "Award",
  "Battery",
  "BrandAmbassador",
  "Browser",
  "Bullseye",
  "Calculator",
  "Calendar",
  "Careers",
  "ChatBubble",
  "Checklist",
  "Clock",
  "Cloud",
  "Coffee",
  "Coin",
  "Coins",
  "Colombia",
  "ComputerMonitor",
  "Conversation",
  "Cross",
  "CustomerSupport",
  "Cycle",
  "DataScience",
  "Document",
  "Endorsement",
  "FinancialInsurance",
  "FinancialServices",
  "Folder",
  "FoodAndBeverage",
  "FullstackDevelopment",
  "Funnel",
  "GlobalForwarding",
  "Globe",
  "Goal",
  "Guatemala",
  "HealthInsurance",
  "Heart",
  "HelpDeskService",
  "Image",
  "Information",
  "Insurance",
  "Insurance02",
  "Investment",
  "Leadership",
  "Lifesaver",
  "Lightbulb",
  "Link",
  "Location",
  "Lock",
  "Mail",
  "Manufacturing",
  "Marketing",
  "Mexico",
  "Microphone",
  "Newspaper",
  "Notebook",
  "Odometer",
  "OfficeBuilding",
  "PaperPlane",
  "Partnership",
  "Partnership02",
  "People",
  "Person",
  "Phillippines",
  "Phone",
  "PieChart",
  "Piggybank",
  "Plus",
  "Pulse",
  "Recruitment",
  "Reload",
  "Sales",
  "Scissors",
  "Search",
  "Skyline",
  "SoftwareDevelopment",
  "Star",
  "Strategy",
  "SupplyChain",
  "Target",
  "Tech",
  "Testimonial",
  "Timer",
  "Toolbox",
  "TransportationAndLogistics",
  "Tree",
  "USA",
  "Umbrella",
  "Unlock",
  "WarehousingAndDistribution",
  "Watch",
  "World"
];

export default lsgIcons;
